(function ($) {

  //iPhone X
    if ($(window).height() == '2436') {
        $('body').addClass('iPx');
    }


    if ($('.popin-booking').length) {
        $('.popin-booking').marypopin({
            triggers: '.btn.booking',
            closeSelector: '.close'
        });
    }

  //popins
    if ($('.popin-filters').length) {
        $('.popin-filters').marypopin({
            triggers: '.btn.filters',
            closeSelector: '.close',
            speed: 500,
            afterOpen: function () {
                if ($(window).width() < 381 && (parseInt($('.popin-content').outerHeight() + $('.popin-top').outerHeight())) > $(window).height()) {
                    $('.popin').addClass('with-bottom-margin');
                }
            },
            beforeOpen: function () {
                $('.popin-filters .agency .form-element .form-element-dropdown').each(function (cpt) {
                    if (cpt > 0) {
                        $(this).remove();
                    } else {
                        $(this).show();
                    }
                    cpt++;
                });
            }
        });
    }

    if ($('.block-estimate-sticky:not(.local)').length) {
        $.post($("#base_route").val() + "/_ajax/resetInstance/", {
        }, function (data) {

            $.ajax({
                url: $('#base_route').attr('value') + "/booking_form/bookingForm",
                type: 'GET',
                data: getFormParameters('.page-content.page-single')
            }).done(function (data) {
                $('.block-estimate-sticky').html(data);

            }).fail(function (data) {
              //Nothing done
            }).always(function (data) {
            });
        });
    }

    if ($('.popin-quoting').length) {
        $('.popin-quoting').marypopin({
            triggers: '#estimate-button,.btn.devis',
            position: 'middle',
            closeSelector: '.close',
            maskClick: false,
            beforeOpen: function (popin, trigger) {
                if ($(trigger).hasClass('devis')) {
                    $('.block-estimate-sticky').html('');
                    $('input[name="display_header"]').val(true);
                }

                $.ajax({
                    url: $('#base_route').attr('value') + "/booking_form/bookingBlankForm",
                    type: 'GET',
                    data: ''
                }).done(function (data) {
                    $('.popin.popin-quoting').html(data);
                    $('.popin-quoting').css('margin-top', parseInt($(window).height() / 2 - $('.popin-quoting').height() / 2 - 44));
                    //Nothing done
                }).always(function (data) {

                });
            },
            afterOpen: function (popin, trigger) {
                $.post($("#base_route").val() + "/_ajax/resetInstance/", {
                }, function (data) {

                    $.ajax({
                        url: $('#base_route').attr('value') + "/booking_form/bookingForm",
                        type: 'GET',
                        data: getFormParameters(trigger)
                    }).done(function (data) {

                        $('.popin.popin-quoting').html(data);
                        spinWaiting('.popin.popin-quoting', false);
                        $('.popin.popin-quoting').css('display', 'block');

                        var h = 25;
                        $('.popin-quoting .popin-content form .block-section').each(function () {
                            h += $(this).outerHeight();
                        });

                        $('.popin-quoting .popin-content').css('height', h + 'px');
                    }).fail(function (data) {
                      //Nothing done
                    }).always(function (data) {
                        setTimeout(function () {
                            $('.popin.popin-quoting select').parent().find('.form-element-dropdown:last-child').remove();
                            $('.popin.popin-quoting select').dropdown({
                                maxItems: 5
                            }).dropdown({
                                maxItems: 5
                            });

                            setTimeout(function () {
                                $('select').each(function () {
                                    var parentElem = $(this).parent();
                                    var parentClass = parentElem.attr('class');
                                    parentClass = parentClass.replace(/\s+/g,' ').trim().split(' ').join('.');
                                    var item = $(".form-element." + parentClass + " .form-element-dropdown")[ 0 ];
                                    $('body').find(item).show();
                                });
                            }, 100);
                        }, 100);
                    });
                });
            },
            beforeClose: function () {
                $('.popin-quoting').removeClass('with-map').css('max-width', '380px');
                if (matchMedia('(max-width: 1023px)').matches) {
                    $('body').height('auto');
                }
            },
            afterClose: function () {
                $('.popin.popin-quoting').html('');

                if ($('body.page-vehicle').length) {
                    var paramsData = getFormParameters($('a.btn.devis'));
                    paramsData.display_price_header = $('input[name="display_price_header"]').val();
                    paramsData.display_header = false;

                    initBookingForm(paramsData);
                }
            }
        });
    }

    function getFormParameters(trigger)
    {

        var params = {
            id_type:                    $('input[name="id_type"]').val(),
            owt_availability:           $('input[name="owt_availability"]').val(),
            one_way_trip:               $('input[name="one_vay_trip"]').val(),
            display_form_tabs:          $('input[name="display_form_tabs"]').val(),
            display_form_tabs_ids:      $('input[name="display_form_tabs_ids"]').val(),
            module_name:                $('input[name="module_name"]').val(),
            action_name:                $('input[name="action_name"]').val(),
            post_params_redirect:       $('input[name="post_params_redirect"]').val(),
            current_categorie_type_url: $('input[name="current_categorie_type_url"]').val(),
            contenu_categorie_type_url: $('input[name="contenu_categorie_type_url"]').val(),
            contenu_agence_url:         $('input[name="contenu_agence_url"]').val(),
            url_type_vehicules:         $('input[name="url_type_vehicules"]').val(),
            url_categorie_vehicules:    $('input[name="url_categorie_vehicules"]').val(),
            posted_data:                $('.form-context .post-data .data').text(),
            display_layout:             $('input[name="display_layout"]').val(),
            display_mode:               $('input[name="display_mode"]').val(),
            display_header:             $('input[name="display_header"]').val(),
            id_vehicule:                $(trigger).attr('data-id-vehicle')
        };

        if ($('input[name="id_agence_depart"]').val() != '') {
            params.id_agence_depart = $('input[name="id_agence_depart"]').val();
        }

        if ($('input[name="id_agence_retour"]').val() != '') {
            params.id_agence_retour = $('input[name="id_agence_retour"]').val();
        }

        return params;
    }

  //input quantity
    var btnQuantityMinus = $('.btn-quantity-minus');
    var btnQuantityPlus = $('.btn-quantity-plus');

    btnQuantityPlus.on('click', function (e) {
        var inputQuantity = $(this).siblings('input[type=text]');
        var quantity = parseInt(inputQuantity.val(), 10);

        e.preventDefault();
        inputQuantity.val(quantity + 1).attr('value', quantity + 1);

        updateTotalPrice();
    });

    btnQuantityMinus.on('click', function (e) {
        var inputQuantity = $(this).siblings('input[type=text]');
        var quantity = parseInt(inputQuantity.val(), 10);

        e.preventDefault();
        inputQuantity.val(quantity - 1).attr('value', quantity - 1);

        if (inputQuantity.val() < 0) {
            inputQuantity.val(0).attr('value', 0);
        }

        updateTotalPrice();
    });

    var updateTotalPrice = function () {
        var price = 0;
        $('ul.packages-list li.package').each(function () {
            price += parseInt($(this).find('.input-quantity').val()) * parseInt($(this).find('span.package-nb-person').text()) * parseFloat($(this).find('div.real-price').text());
        });

        $.post($('#base_route').val() + "/_ajax/amountTransform/", {number: price}, function (data) {
            var obj = jQuery.parseJSON(data);
            $('span.total-price span').text(html_entity_decode(obj.result) + '');
        }).fail(function () {
        });
    };


  //filters
    $('.filters-list .filter >a').on('click', function (e) {
        e.preventDefault();
        $('.filter-content').fadeOut();
        $('body').addClass('filters');
        $('#mask').addClass('filter');
        $(this).siblings('.filter-content').fadeIn();
    });


    $('.filters-list .filter input[type="submit"]').on('click', function () {
        $('.filter-content').fadeOut();
        $('#mask').removeClass('filter');
        $('body').removeClass('filters');
    });


    $('#mask').on('click', function () {
        if ($(this).hasClass('menu')) {
            $('body').removeClass('fixed');
            $('#mask').removeClass('menu');
            $('.icon-hamburger').removeClass('is-active');
            $('.block-nav-mobile').removeClass('open').css('width', '100%');
        } else {
            $('.filter-content').fadeOut();
            $('#mask').removeClass('filter');
            $('body').removeClass('filters');
        }
    });

    $('.btn.filters').on('click', function (e) {
        e.preventDefault();
        $('body').addClass('fixed');
        $('.block-filters-mobile').addClass('open');

        setTimeout(function () {
            var contentHeight = parseInt(document.getElementById('mobile-popin-content').offsetHeight);
            var screenHeight  = parseInt($(window).height());

            if (contentHeight < screenHeight && $('.popin-filters .popin-content').outerWidth() < $(window).width()) {
                $('.popin .popin-bottom').css('top', '100%');
            }
            $('.popin .popin-bottom').fadeIn();
        }, 300);

    });

    $('.block-filters-mobile .block-filters-mobile-top a.close').on('click', function (e) {
        e.preventDefault();
        $('.block-filters-mobile').removeClass('open');
        $('body').removeClass('fixed');
    });

  //form-elements
    $('#slider, #slider-mobile').slider({
        range: true,
        min: 0,
        max: 3000,
        step: 100,
        values: [0, 3000],
        slide: function (event, ui) {
            $('#slider-min, #slider-min-mobile').html(ui.values[0]);
            $('#slider-max, #slider-max-mobile').html(ui.values[1] + ' km');
        },
        stop: function (event, ui) {
        }
    });


    if ($.isFunction($.fn.flickity) && $('.slider').length) {
        setTimeout(function () {
            $('.slider').each(function () {
                var $that = $(this);
                if ($that.children().length > 1) {
                    $that.children().removeClass('active');
                    $that.flickity({
                        draggable: true,
                        groupCells: true,
                        cellAlign: 'left',
                        wrapAround: false,
                        autoPlay: false,
                        pageDots: true,
                        imagesLoaded: true,
                        arrowShape: {
                            x0: 0,
                            x1: 0, y1: 0,
                            x2: 0, y2: 0,
                            x3: 0
                        },
                        prevNextButtons: false
                    });

                    $that.on('dragMove.flickity', function ( event, pointer, moveVector ) {
                            $that.find("img").addClass("prevent");
                    });
                    $that.on('dragEnd.flickity', function ( event, pointer ) {
                            setTimeout(function () {
                                $that.find("img").removeClass("prevent");
                            }, 10);
                    });
                }
            });

        }, 100);
    }

  // slider comments
    if ($(".comments-list").length > 0) {
        $(".comments-list").flickity({
            draggable: true,
            wrapAround: true,
            autoPlay: false,
            pageDots: true,
            imagesLoaded: true,
            prevNextButtons: false,
            groupCells: 1
        });
    }

  //slider photo
    function sliderPhoto()
    {

        var popin = $('.popin-photo');
        if (!popin.length) {
            return;
        }
        var images = $('img[data-popin-photo-num]');

        images.on("click",function () {
            if (this.classList.contains("prevent")) {
                return;
            }
            var index = this.getAttribute("data-popin-num");
            var pop = document.querySelector('.popin-photo[data-popin-num="' + index + '"]');
            pop.classList.add("open");
            var num = this.getAttribute("data-popin-photo-num");
            var slider = $(pop).find('.slider-photo');
            slider.flickity({
                draggable: true,
                wrapAround: true,
                autoPlay: false,
                pageDots: false,
                prevNextButtons: true,
                initialIndex: num - 1,
                lazyLoad: 1,
                on: {
                    ready: function (index) {
                        $('.page-vehicle.pwa #gallery .popin-photo span.current').text(index);
                    },
                    change: function ( index ) {
                        if ($('.page-vehicle.pwa #gallery').length) {
                            $('.page-vehicle.pwa #gallery .popin-photo span.current').text(index + 1);
                        }
                    },
                    select: function ( index ) {
                        if ($('.page-vehicle.pwa #gallery').length) {
                            $('.page-vehicle.pwa #gallery .popin-photo span.current').text(index + 1);
                        }
                    }
                }
            });
            var close = $(pop).find('.btn-close');
            close.on("click", function () {
                pop.classList.add('close');
                setTimeout(function () {
                    popin.removeClass('close');
                    popin.removeClass('open');
                    slider.flickity('destroy');
                }, 300);
            });
        });
    }

    sliderPhoto();

  //product like
    $('.product .icon-like, .block-infos .icon-like, .menu-item .icon.like').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('liked');
    });

  //product carousel
    if ($('.pwa .product.carousel .img-container').length > 0) {
        $('.product.carousel .img-container').slick({
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: 0,
        });
    }
  //menu mobile
    $('.btn.menu-mobile').on('click', function (e) {
        e.preventDefault();
        $('.icon-hamburger').toggleClass('is-active');
        $('#mask').toggleClass('menu');
        $('body').toggleClass('fixed');
        $('.block-nav-mobile').toggleClass('open');
        $('section#burger-menu-background').fadeIn();
        if ($('.block-nav-mobile.open').length === 1) {
            $('.block-subnav').addClass('disabled');
            $('.block-nav-mobile.open').css('width', '75%');
        } else {
            $('.block-subnav').removeClass('disabled');
            $('.block-nav-mobile').css('width', '100%');
        }
    });

    $('section#burger-menu-background').on('click', function (e) {
        e.preventDefault();
        $('.block-nav-mobile').toggleClass('open');
        $('.icon-hamburger').toggleClass('is-active');
        $('body').toggleClass('fixed');
        $('section#burger-menu-background').fadeOut();
        if ($('.block-nav-mobile.open').length === 1) {
            $('.block-subnav').addClass('disabled');
            $('.block-nav-mobile.open').css('width', '75%');
        } else {
            $('.block-subnav').removeClass('disabled');
            $('.block-nav-mobile.open').css('width', '100%');
        }
    });

    $('.block-nav-mobile').removeClass('open');

    if ($('#block-nav-mobile-content').length > 0) {
        var $blockNavMobileContent = document.getElementById('block-nav-mobile-content');
        var mc = new Hammer($blockNavMobileContent);

        mc.on('swipeleft', function (ev) {
            $('.block-nav-mobile').toggleClass('open');
            $('body').toggleClass('fixed');
            $('#mask').toggleClass('menu');
            $('.icon-hamburger').toggleClass('is-active');
        });
    }

  //carousel single
    if ($('.block-breadcrumbs.carousel .img-container, .block-header.carousel .img-container').length) {
        $('.block-breadcrumbs.carousel .img-container, .block-header.carousel .img-container').slick({
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: 0
        });
    }

  //main menu
    if ($('body').attr('id') !== 'home') {
        $('.block-nav #menu-item-explore').on('mouseenter', function () {
            $('.block-subnav').addClass('show');
        });

        $('.block-nav').on('mouseleave', function () {
            $('.block-subnav').removeClass('show');
        });
    } else {
        $('.block-subnav').addClass('show');
    }

  //anchors
    $('.main-bar-single-mobile-sticky .block-infos .anchors').each(function (i, e) {
        var Sum = 0;

        $(this).children('li').each(function (i, e) {
            Sum += $(e).outerWidth(true);
        });

        if (Sum > $(this).outerWidth()) {
            $(this).outerWidth(Sum + 30);
        }
    });

    $('.main-bar-single:not(.bottom-banner):not(.desktop) .block-infos .anchors').each(function (i, e) {
        var Sum = 0;

        $(this).children('li').each(function (i, e) {
            Sum += $(e).outerWidth(true);
        });

        if (Sum > $(this).outerWidth()) {
            $(this).outerWidth(Sum + 30);
        }
    });

    var xDown = null;
    var yDown = null;

    if ($('.anchors-container').length) {
        var confObject = {capture: false, passive: true};
        document.addEventListener('touchstart', handleTouchStart, confObject);

        if ($('#mobile-scroll-section-height-adjust-touch').length && $('#mobile-scroll-section-height-adjust-click').length) {
            document.addEventListener('touchmove', handleTouchMove, confObject);
            document.addEventListener('scroll', handleScrollMove, confObject);
            $('.anchors-container ul.anchors li.anchor').click(function () {
                $('#mobile-scroll-section-height-adjust').text($('#mobile-scroll-section-height-adjust-click').text());
            });
        }
    }

    function getTouches(evt)
    {
        return evt.touches ||             // browser API
        evt.originalEvent.touches; // jQuery
    }

    function handleTouchStart(evt)
    {
        var firstTouch = getTouches(evt)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
    };

    function handleScrollMove(evt)
    {
        heightAdjustUpdate();
    };

    function heightAdjustUpdate()
    {
        $('#mobile-scroll-section-height-adjust').text($('#mobile-scroll-section-height-adjust-touch').text());
    }

    function handleTouchMove(evt)
    {
        heightAdjustUpdate();
    };

    var firstSectionTop = undefined;

    if ($('div.first-block').length && $('#firstSectionTop').text() == '') {
        firstSectionTop = $('div.first-block').offset().top;
        $('#firstSectionTop').text(firstSectionTop);
    } else {
        if ($('#fisrtSectionTop').text() != '') {
            firstSectionTop = parseInt($('#firstSectionTop').text());
        }
    }

    $(document).on('scroll', function () {
        var screenTop = $(document).scrollTop();
        var backButtonSelector = '.btn-back.picto.picto-arrow-left.image-bkg';

        if (screenTop >= ($('.header.img-container img').height() - 70)) {
            $(backButtonSelector).fadeOut();
        } else {
            if (!$(backButtonSelector + ':visible').length) {
                $(backButtonSelector).fadeIn();
            }
        }

        if (screenTop >= (firstSectionTop - 2)) {
            if ($(window).width() >= 1022 && $('.page-vehicle .sticky-desktop').length === 1 && $('div.first-block').length) {
                $('.page-vehicle .main-bar-single.sticky-desktop.active').attr('style', 'top: 0px !important');
            }
            $('.block-estimate-sticky').addClass('below-main-bar');
        } else {
            if ($('.page-vehicle .sticky-desktop.active').length === 1) {
                $('.page-vehicle .main-bar-single.sticky-desktop.active').attr('style', 'top: -140px !important');
            }

            $('.block-estimate-sticky').removeClass('below-main-bar');
        }

        var selector = '.main-bar-single-mobile-sticky.show';
        if ($(window).width() >= 1022 ) {
            selector = '.main-bar-single.sticky-desktop.active';
        }

        if ($('#separator-div').length && $('#separator-div').offset().top - $(window).scrollTop() <= $(selector).height()) {
            $('#below-separator').attr('data-value', '1');
            $('.anchors-container ul.anchors .active').removeClass('active');
            $('.borderbottom').attr('style', '');
        } else {
            if (parseInt($('#below-separator').attr('data-value')) === 1 && !$('.anchors-container ul.anchors li:last-child').hasClass('active')) {
                $('.anchors-container ul.anchors li:last-child').addClass('active');
            }
            $('#below-separator').attr('data-value', '0');
        }

    });

  //menu swipe mobile
    if (matchMedia('(max-width: 1023px)').matches) {
        $('.submenu-container .submenu').each(function (i, e) {
            var Sum = 0;

            $(this).children('li').each(function (i, e) {
                Sum += $(e).outerWidth(true);
            });

            if (Sum > $(this).outerWidth()) {
                $(this).outerWidth(Sum + 30);
            }
        });
    }

    var $activeItemContainer;

    if (matchMedia('(max-width: 1023px)').matches) {
        if ($('body').attr('id') == 'page-single') {
            $activeItemContainer = $('.main-bar-single-mobile-sticky');
        } else if ($('body').attr('id') == 'page-vehicle') {
            $activeItemContainer = $('.main-bar-single-mobile-sticky');
        } else if (!$('body').hasClass('page-vehicle')) {
            $activeItemContainer = $('.main-bar-single:not(.bottom-banner):not(.desktop)');

          //$('.main-bar-single:not(.bottom-banner)').sticky({ topSpacing: 0 });
        }

      //console.log($activeItemContainer);
    } else  {
        if ($('body').attr('id') == 'page-vehicle') {
            $activeItemContainer = $('.sticky-desktop');
        } else if ($('body').attr('id') == 'page-single') {
            $activeItemContainer = $('.main-bar-single:not(.bottom-banner):not(.desktop)');
        }
    }


  //smoothscroll
    var $activeItemContainer;
    if (matchMedia('(max-width: 1021px)').matches) {
        $activeItemContainer = $('.main-bar-single-mobile-sticky');
    }
    if (matchMedia('(min-width: 1022px)').matches) {
        $activeItemContainer = $('.main-bar-single:not(.bottom-banner):not(.desktop)');
    }

    if ($('body.page-promo-list.page-circuit-list.pwa, body.page-vehicle.pwa').length) {
        var $menuItems = $activeItemContainer.find('.anchors-container .anchors .anchor'),
        activeMenuItems = $activeItemContainer.find('.anchors-container .anchors .anchor.active'),
        position = activeMenuItems.position(),
        barWidth = activeMenuItems.innerWidth();
    }

    var $blockEstimateSticky = $('.block-estimate-sticky');

    $(window).resize(function () {
        waitForFinalEvent(testEstimateSticky, 100, "resize blocks height with quartier");
    });
    testEstimateSticky();

    function testEstimateSticky()
    {
        $blockEstimateSticky.toggleClass('no-sticky', window.innerHeight < $blockEstimateSticky.height() + 200);
    }

    var waitForFinalEvent = (function () {
        var timers = {};
        return function (callback, ms, uniqueId) {
            if (!uniqueId) {
                uniqueId = "Don't call this twice without a uniqueId";
            }
            if (timers[uniqueId]) {
                clearTimeout(timers[uniqueId]);
            }
            timers[uniqueId] = setTimeout(callback, ms);
        };
    })();

    function updateActiveBottomBarById(id)
    {

        if ($menuItems.eq(id).length) {
            $activeItemContainer.find('.anchors-container .borderbottom').css({
                left: $menuItems.eq(id).position().left,
                width: $menuItems.eq(id).innerWidth()
            });
        }
    }

  //smoothscroll
    if ($('body.page-promo-list.page-circuit-list.single.pwa, body.page-vehicle.pwa').length) {
        var anchors = undefined;

        anchors = {
            triggers: $('.block-infos .anchors a'),

            init: function () {
                var self = this;

                self.triggers.click(function (e) {
                    var findAttr = $(this).attr('href');

                    if ($(findAttr).offset() === undefined) {
                        return;
                    }

                    e.preventDefault();
                    self.scrollToAnchor(findAttr);
                });
            },
            scrollToAnchor: function (anchor) {
                var self = this;
                var anchorPos = $(anchor).offset();

                if ($(window).width() < 1022) {
                    $("html, body").animate({ scrollTop: anchorPos.top - parseInt($('#mobile-handlescroll-top').text()) });
                } else {
                    $("html, body").animate({ scrollTop: anchorPos.top - parseInt($('#handlescroll-top').text()) });
                }
            }
        };
        anchors.init();

      //dynamic anchors
      //block booking mobile sticky
        var handleScroll = undefined;
        var topbarHeight = $(".main-bar-single:not(.bottom-banner):not(.desktop)").outerHeight();

        handleScroll = {
            capability: 0,
            topPos: undefined,
            $blockBookingMobile: $('.block-booking-mobile'),
            $mainBarSingleMobileSticky: $('.main-bar-single-mobile-sticky'),
            $anchors: $activeItemContainer.find('.anchors-container .anchors .anchor'),
            nbAnchors: $activeItemContainer.find('.anchors-container .anchors .anchor').length,
            $blockSection: $('.block-section--scroll'),
            currentInternalSectionId: 0,
            oldInternalSectionId: 0,

            init: function () {
                var self = this;

                if (window.pageYOffset != undefined) {
                    self.capability = 1;
                } else if (document.body && document.body.scrollTop != undefined) {
                    self.capability = 2;
                }

                $(window).scroll(function () {
                    self.scrollCheck();
                });
            },
            scrollCheck: function () {
                var self = this;

                switch (self.capability) {
                    case 1 :
                        self.topPos = window.pageYOffset;
                    break;
                    case 2 :
                        self.topPos = document.body.scrollTop;
                    break;
                    default :
                        self.topPos = 0;
                    break;
                }
                handleSticky();
                anchorsUnderline();

                if ($('#module_name').val() == 'circuits' && $('#action_name').val() == 'fiche') {
                    checkProgram();
                }
            }
        };

        handleScroll.init();
        updateActiveSection();
    }


    function handleSticky()
    {
        var topSpacing = $('div.first-block').offset().top;
        if ($(window).width() < 1022 && $('div.first-block-mobile').length) {
            topSpacing = $('div.first-block-mobile').offset().top;
        }
        if (handleScroll.topPos >= topSpacing && $(window).width() < 1022) {
            handleScroll.$mainBarSingleMobileSticky.addClass('show');
        } else {
            handleScroll.$mainBarSingleMobileSticky.removeClass('show');
            if ($(window).width() < 1022) {
                $('.main-bar-single.desktop .anchors-container ul.anchors li.anchor').each(function () {
                    $(this).removeClass('active');
                    $('.borderbottom').attr('style', '');
                });
                $('.main-bar-single.desktop .anchors-container ul.anchors li.anchor:first-child').addClass('active');
            }
        }
    }

    function anchorsUnderline()
    {

        var adjust = parseInt($('#scroll-section-height-adjust').text());
        if ($(window).width() < 1022) {
            adjust = parseInt($('#mobile-scroll-section-height-adjust').text())
        }
        for (var i = 0; i < handleScroll.nbAnchors; i++) {
            if ((handleScroll.topPos + parseInt($('#handlescroll-width').text()) + topbarHeight) > (handleScroll.$blockSection.eq(i).offset().top + adjust)) {
                handleScroll.currentInternalSectionId = i;
            }
        }
        if (handleScroll.oldInternalSectionId != handleScroll.currentInternalSectionId) {
            updateActiveSection();
        }
    }

    function updateActiveSection()
    {

      //alert(handleScroll.currentInternalSectionId);
        handleScroll.$anchors.eq(handleScroll.oldInternalSectionId).removeClass('active');
        handleScroll.oldInternalSectionId = handleScroll.currentInternalSectionId;
        handleScroll.$anchors.eq(handleScroll.currentInternalSectionId).addClass('active');
        handleScroll.$anchors.eq(handleScroll.currentInternalSectionId).find('a').focus();

      //currentInternalSectionId passe tout de suite à deux dès que l'on commence à scroller.
        updateActiveBottomBarById(handleScroll.currentInternalSectionId);

        if (matchMedia('(max-width: 1024px)').matches) {
            var offset       = 0;
            var anchorsWidth = 0;
            var screenWidth  = $(window).width();
            var anchorSelector        = '.main-bar-single-mobile-sticky .anchors-container .anchors .anchor';
            var anchorsContainerWidth = $('.main-bar-single-mobile-sticky .anchors-container .anchors').width();

            for (var i = 0; i < handleScroll.$anchors.length; i++) {
                if (i == 0) {
                    $(anchorSelector).eq(i).attr('data-width', 20);
                    anchorsWidth += 20;
                } else {
                    $(anchorSelector).eq(i).attr('data-width', $(anchorSelector).eq(i).width());
                    anchorsWidth += $(anchorSelector).eq(i).width();
                }
            }

            for (var i = 0; i < handleScroll.currentInternalSectionId; i++) {
                offset += $(anchorSelector).eq(i).width();

                if (offset > (anchorsContainerWidth - screenWidth) && anchorsContainerWidth <= offset) {
                    offset = (anchorsContainerWidth - screenWidth);
                }
            }

            $('.main-bar-single-mobile-sticky .anchors-container .anchors').css(
                'transform',
                'translateX(' + -offset + 'px' + ')'
            );
        }
    }

    $('.page-vehicle .main-bar-single:visible')
    .on('sticky-start', function () {
        $('.page-vehicle .block-estimate-sticky').addClass('below-main-bar');
    })
    .on('sticky-end', function () {
        $('.page-vehicle .block-estimate-sticky').removeClass('below-main-bar');
    });

  //about this program
    $('.block-section a.more, .side-widget.testimonials .testimonial .text-container .more').on('click', function (e) {
        e.preventDefault();
        $(this).parent().addClass('show').slideDown();
        $(this).parent().find('p').attr('style', 'margin-bottom: 4px;line-height: 30px;');
        $(this).remove();
    });

  //program map single

    var mapsInit = false;
    var partialProgramMap;
    var partialProgramMapWrapper = $('#partial-program-map-wrapper');
    var fullProgramMap;
    var fullProgramMapWrapper = $('#full-program-map-wrapper');
    var markersLatLng = [];
    var markersMapsLatLng = [];
    var markers = [];
    var currentMarkerId = -1;
    var oldMarkerId = 0;
    var $daysList = $('.timeline-container .days-list');
    var dayHeight = $daysList.find(".day").outerHeight();
    var $days = $daysList.find('.day');
    var nbDays = $days.length;
    var daysHeight = dayHeight * nbDays;
    var margin = 40;
    var wh = $(window).height();
    var wrapperPaddingBottom = 46;  /* 46 is padding bottom of main wrapper */
    var topHeight = topbarHeight + margin;
    var footerHeight;
    var bottomHeight;
    var boundsFullDirection = null;
    var boundsPartialDirection = null;
    var markerImage = null;
    var mapToBePanned = null;
    var marqueurPartialDeparture = null;
    var marqueurPartialArrival = null;
    var mark = null;

    var movingMode = 'WALKING';

    function initProgram()
    {
        footerHeight = $("footer").outerHeight(); //border
        bottomHeight = footerHeight + $("#offer-list").outerHeight() + $("#comments").outerHeight() + margin + wrapperPaddingBottom;

        if ($('#partial-program-map').length && $('#full-program-map').length) {
            $('#partial-program-map').sticky({
                topSpacing: topHeight,
                bottomSpacing: bottomHeight,
                zIndex: 1
            });
            $('#full-program-map').sticky({
                topSpacing: topHeight,
                bottomSpacing: bottomHeight,
                zIndex: 1
            });
            initProgramMap();
        }
    }

    function createMarkers()
    {

        $('.timeline-container .days-list .day').each(function () {
            if ($(this).attr('data-lat') !== undefined && $(this).attr('data-lng') !== undefined) {
                var LatLng = [];
                LatLng.push($(this).attr('data-lat'), $(this).attr('data-lng'));
                markersLatLng.push(LatLng);
            }
        });
        var LatLng = [];
        LatLng.push($('.day-coords.last').attr('data-lat'), $('.day-coords.last').attr('data-lng'));
        markersLatLng.push(LatLng);
    }
    createMarkers();

    function checkProgram()
    {
        handleDays();

        var documentHeight = $(document).height();
        var maxScroll = documentHeight - wh;
        var timelineHeight = (handleScroll.topPos / maxScroll) * daysHeight;

        $('.current-timeline').height((wh * .5) - $daysList[0].getBoundingClientRect().top);
    }

    function handleDays()
    {

        var marginDay = 20;
        for (var i = 0; i < nbDays; i++) {
            if ( ( handleScroll.topPos + (wh * .5)) > ($days.eq(i).offset().top + marginDay) ) {
                currentMarkerId = i;
            }
        }

        if (( handleScroll.topPos + (wh * .5)) < $daysList[0].getBoundingClientRect().top) {
            currentMarkerId = -1;
        }

        if (oldMarkerId != currentMarkerId) {
            if (oldMarkerId == (nbDays - 1) && currentMarkerId == (nbDays - 2)) {
                updateCurrentDay();
            } else {
                updateCurrentDay();
            }
        }

        if ($('.day[data-day-index="' + (currentMarkerId + 1) + '"]').length) {
            var pc = (((wh * .5) - $('.day[data-day-index="' + (currentMarkerId + 1) + '"]')[0].getBoundingClientRect().top - 50) / $('li.day.active').height());
            var nbPoints = $('.day[data-day-index="' + (currentMarkerId + 1) + '"] span.day-coords').length + 1;
            var value = Math.round(nbPoints * pc);

            if (value <= nbPoints && value > 0) {
              //console.log('.day[data-day-index="' + (currentMarkerId + 1) + '"] span.day-coords[data-coord-position="' + value +'"]');
                var lat = parseFloat($('.day[data-day-index="' + (currentMarkerId + 1) + '"] span.day-coords[data-coord-position="' + value + '"]').attr('data-lat'));
                var lng = parseFloat($('.day[data-day-index="' + (currentMarkerId + 1) + '"] span.day-coords[data-coord-position="' + value + '"]').attr('data-lng'));


                if (lat && lat != 0 && lng && lng != 0) {
                    fullProgramMap.setCenter(new google.maps.LatLng(lat, lng));

                    if (mark != null) {
                        mark.setMap(null);
                    }
                    mark = new google.maps.Marker({
                      //label: 'Départ',
                        position: new google.maps.LatLng(
                            lat,
                            lng
                        ),
                    map: fullProgramMap,
                    });
                      //mark.setAnimation(google.maps.Animation.BOUNCE);
                      mark.setIcon(markerImage);
                }
            }
        }


        if ($(window).width() > 1022) {
            if ($('.day.active').length === 1 || $('.day.active').length === $('.day').length) {
                if ($('.day.active').length === 1 && marqueurPartialDeparture != null && !(marqueurPartialDeparture.getMap() instanceof google.maps.Map)) {
                    marqueurPartialDeparture.setMap(partialProgramMap);
                    marqueurPartialArrival.setMap(null);
                } else {
                    if ($('.day.active').length == $('.day').length && marqueurPartialArrival != null && !(marqueurPartialArrival.getMap() instanceof google.maps.Map)) {
                        marqueurPartialDeparture.setMap(null);
                        marqueurPartialArrival.setMap(partialProgramMap);
                    }
                }

                if ($('#full-program-map-wrapper:visible').length) {
                    partialProgramMapWrapper.show();
                    fullProgramMapWrapper.hide();

                    $('#partial-program-map').sticky({
                        topSpacing: topHeight,
                        bottomSpacing: bottomHeight,
                        zIndex: 10
                    });
                }

                var percent = (((wh * .5) - $daysList[0].getBoundingClientRect().top - 25) / $('li.day.active').height()) * 100;
                partialProgramMap.fitBounds(boundsPartialDirection);
            } else {
                if ($('#partial-program-map-wrapper:visible').length) {
                    partialProgramMapWrapper.hide();
                    fullProgramMapWrapper.show();

                    $('#full-program-map').sticky({
                        topSpacing: topHeight,
                        bottomSpacing: bottomHeight,
                        zIndex: 10
                    });
                }
            }
        } else {
            partialProgramMapWrapper.hide();
            fullProgramMapWrapper.hide();
        }
    }

    function updateCurrentDay(forceCenter)
    {

        mapToBePanned = partialProgramMap;
        if ($('#partial-program-map-wrapper:visible').length) {
            mapToBePanned = partialProgramMap;
        } else if ($('#full-program-map-wrapper:visible').length) {
            mapToBePanned = fullProgramMap;
        }

        if (!mapsInit) {
            return;
        }

        $days.eq(oldMarkerId).removeClass('active');
        var cond = (oldMarkerId < currentMarkerId);

        oldMarkerId = currentMarkerId;

        $days.eq(currentMarkerId).addClass('active');

        for (var i = 0; i < currentMarkerId; i++) {
            $days.eq(i).addClass('active');
        }

        for (var i = 0; i < nbDays; i++) {
            if (markers[i]) {
                markers[i].setIcon('../../images/pwa/common/pin-gmap-out.png');
            }
        }

        var index = currentMarkerId - 1 ;

        if (currentMarkerId > 0 && markersLatLng[index]  != undefined && cond) {
          // programMap.panTo( markersMapsLatLng[currentMarkerId] ); /* gmap pan */
            panTo(markersLatLng[index][0], markersLatLng[index][1]);
          //markers[index].setIcon(markerImage);
            if (forceCenter == true) {
                fullProgramMap.setCenter(new google.maps.LatLng(markersLatLng[index][0], markersLatLng[index][1]));
            }
        }
    }

    var panPath = [];
    var panQueue = [];
    var STEPS = 4;

    function panTo(newLat, newLng)
    {
        if (panPath.length > 0) {
          // We are already panning...queue this up for next move
            panQueue.push([newLat, newLng]);
        } else {
          // Lets compute the points we'll use
            panPath.push("LAZY SYNCRONIZED LOCK");  // make length non-zero - 'release' this before calling setTimeout
            var curLng = mapToBePanned.getCenter().lng();
            var curLat = mapToBePanned.getCenter().lat();
            var dLat = (newLat - curLat) / STEPS;
            var dLng = (newLng - curLng) / STEPS;

            for (var i = 0; i < STEPS; i++) {
                panPath.push([curLat + dLat * i, curLng + dLng * i]);
            }
            panPath.push([newLat, newLng]);
            panPath.shift();      // LAZY SYNCRONIZED LOCK
            setTimeout(doPan, 20);
        }
    }

    function doPan()
    {
        var next = panPath.shift();
        if (next != null) {
          // Continue our current pan action
            mapToBePanned.panTo(new google.maps.LatLng(next[0], next[1]));
            mapToBePanned.setZoom(parseInt($('#circuit-zoom-level').text()));
            setTimeout(doPan, 20);
        } else {
          // We are finished with this pan - check if there are any queue'd up locations to pan to
            var queued = panQueue.shift();
            if (queued != null) {
                panTo(queued[0], queued[1]);
            }
        }
    }

    function initProgramMap()
    {

        if (typeof google === 'object' && typeof google.maps === 'object') {
            boundsFullDirection = new google.maps.LatLngBounds();
            boundsPartialDirection = new google.maps.LatLngBounds();

            markerImage = {
                url: '../../images/pwa/common/pin-gmap.png',
                origin: new google.maps.Point(-0, -12),
            };
        }
        if (typeof google === 'object' && typeof google.maps === 'object') {
          //Départ
            marqueurPartialDeparture = new google.maps.Marker({
                animation: google.maps.Animation.DROP,
                position: new google.maps.LatLng(
                    parseFloat($('.day.first').attr('data-lat')),
                    parseFloat($('.day.first').attr('data-lng'))
                ),
            });
            marqueurPartialDeparture.setIcon(markerImage);

          //Arrivée
            marqueurPartialArrival = new google.maps.Marker({
                animation: google.maps.Animation.DROP,
                position: new google.maps.LatLng(
                    parseFloat($('.day-coords.last').attr('data-lat')),
                    parseFloat($('.day-coords.last').attr('data-lng'))
                ),
            });
            marqueurPartialArrival.setIcon(markerImage);
        }

      //Carte par défaut
        partialProgramMap = new google.maps.Map(document.getElementById('partial-program-map'), {
            zoom: 10,
            center: {
                lat: 48.8589101,
                lng: 2.3119548
            }
        });
      //Carte par défaut
        fullProgramMap = new google.maps.Map(document.getElementById('full-program-map'), {
            zoom: parseInt($('#circuit-zoom-level').text()),
            center: {
                lat: 48.8589101,
                lng: 2.3119548
            }
        });

        var image = '../../images/pwa/common/pin-gmap-out.png';
        var icon = {
            url: image,
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(50,50),
            scaledSize: new google.maps.Size(100,100)
        }
        var waypts = [];

        var fullPathWayPointsFullDirection = [];
        var fullPathWayPointsPartialDirection = [];

        $('li.day').each(function () {

            waypts = [];

            if ($(this).attr('data-lat') !== undefined && $(this).attr('data-lng') !== undefined) {
                fullPathWayPointsFullDirection.push({
                    location: new google.maps.LatLng(parseFloat($(this).attr('data-lat')), parseFloat($(this).attr('data-lng'))),
                    stopover: true
                });
                waypts.push({
                    location: new google.maps.LatLng(parseFloat($(this).attr('data-lat')), parseFloat($(this).attr('data-lng'))),
                    stopover: true
                });
            }
            var cpt = 1;
            var coords = $(this).find('span.day-coords');
            var increment = Math.ceil(coords.length / 22);

            coords.each(function () {
                if ($(this).attr('data-lat') !== undefined && $(this).attr('data-lng') !== undefined) {
                    fullPathWayPointsFullDirection.push({
                        location: new google.maps.LatLng(parseFloat($(this).attr('data-lat')), parseFloat($(this).attr('data-lng'))),
                        stopover: true
                    });

                    if (coords.length < 20) {
                            waypts.push({
                                location: new google.maps.LatLng(parseFloat($(this).attr('data-lat')), parseFloat($(this).attr('data-lng'))),
                                stopover: true
                                });
                    } else {
                        if ($(this).attr('data-lat') !== undefined && $(this).attr('data-lng') !== undefined && (cpt % increment) == 0) {
                            waypts.push({
                                location: new google.maps.LatLng(parseFloat($(this).attr('data-lat')), parseFloat($(this).attr('data-lng'))),
                                stopover: true
                            });
                        }
                    }
                }
                cpt++;
            });
            fullPathWayPointsPartialDirection.push(waypts);
        });

        var zoomVal = 0;
        var lats = 0;
        var lngs = 0;

        for (var key in fullPathWayPointsFullDirection) {
            if (fullPathWayPointsFullDirection.hasOwnProperty(key)) {
                lats += fullPathWayPointsFullDirection[key].location.lat();
                lngs += fullPathWayPointsFullDirection[key].location.lng();
            }
        }

        var centerLatFullDirection = lats / fullPathWayPointsFullDirection.length;
        var centerLngFullDirection = lngs / fullPathWayPointsFullDirection.length;

        lats = 0;
        lngs = 0;

        var dataSize = 0;

        for (var key in fullPathWayPointsPartialDirection) {
            if (fullPathWayPointsPartialDirection.hasOwnProperty(key)) {
                var arrData = fullPathWayPointsPartialDirection[key];
                dataSize += arrData.length;
                for (var innerKey in arrData) {
                    lats += arrData[innerKey].location.lat();
                    lngs += arrData[innerKey].location.lng();
                    boundsPartialDirection.extend(arrData[innerKey].location);
                }
            }
        }

        var centerLatPartialDirection = lats / dataSize;
        var centerLngPartialDirection = lngs / dataSize;

        partialProgramMap = new google.maps.Map(document.getElementById('partial-program-map'), {
            zoom: 10,
            center:
            new google.maps.LatLng(parseFloat($('.day.first').attr('data-lat')), parseFloat($('.day.first').attr('data-lng')))
        });

        fullProgramMap = new google.maps.Map(document.getElementById('full-program-map'), {
            zoom: parseInt($('#circuit-zoom-level').text()),
            center:
            new google.maps.LatLng(parseFloat($('.day.first').attr('data-lat')), parseFloat($('.day.first').attr('data-lng')))
        });


        if ($('ul.kml-sources li.full').attr('data-url') != '') {
            console.log('Request to ' + $('ul.kml-sources li.full').attr('data-url'));
            var kmlLayer = new google.maps.KmlLayer($('ul.kml-sources li.full').attr('data-url'), {
                suppressInfoWindows: true,
                preserveViewport: false,
                map: partialProgramMap
            });
        }

        $('ul.kml-sources li.step').each(function () {
            if ($(this).attr('data-url') != '') {
                console.log('Request to ' + $(this).attr('data-url'));
                var kmlLayer = new google.maps.KmlLayer($(this).attr('data-url'), {
                    suppressInfoWindows: true,
                    preserveViewport: true,
                    map: fullProgramMap
                });
            }
        });

        for (var i = 0; i < markersLatLng.length; i++ ) {
            var position = new google.maps.LatLng(
                markersLatLng[i][0],
                markersLatLng[i][1]
            );
            markersMapsLatLng.push(position);

            var marker = new google.maps.Marker({
                position: position,
                map: fullProgramMap,
                image: icon
            });
            markers.push(marker);
        }

        mapsInit = true;

        updateCurrentDay();
    }

    window.initProgram = initProgram;

    if ($('body.page-promo-list.page-circuit-list.pwa').length && matchMedia('(max-width: 1024px)').matches) {
        $('.days-list').slick({
            arrows: false,
            dots: true,
            infinite: false,
            variableWidth: true
        });

        var $dots = $('.days-list .slick-dots li');
        var nbDots = $dots.length;

        $dots.eq(0).addClass('active');

        $('.days-list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            window.scrollBy(0, 1); window.scrollBy(0, -1);
        });

        $('.days-list').on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            for (var i = 0; i <= nextSlide; i++) {
                $dots.eq(i).addClass('active');
            }

            for (var j = nbDots; j > nextSlide; j--) {
                $dots.eq(j).removeClass('active');
            }

            window.scrollBy(0, 1); window.scrollBy(0, -1);
        });


        $('.days-list .slick-dots li').each(function (i, e) {
            var buttonText;

            buttonText = $(this).find('button').text();
            buttonText = 'Jour ' + buttonText;

            $(this).find('button').text(buttonText);
        });

        $('.days-list .slick-dots').each(function (i, e) {
            var Sum = 0;

            $(this).children('li').each(function (i, e) {
                Sum += $(e).outerWidth(true);
            });

            if (Sum > $(this).outerWidth()) {
                $(this).outerWidth(Sum + 30);
            }
        });
    }

  //page carousel
    if ($('.page-content .media-container .img-container').length) {
        $('.page-content .media-container .img-container').slick({
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: 0
        });
    }

  //testimonail widget carousel
    if ($('.testimonials-carousel').length) {
        $('.testimonials-carousel').slick({
            arrows: false,
          // autoplay: true,
            dots: true,
            centerMode: true,
            centerPadding: 0,
            pauseOnHover: true
        });
    }

  //faq
    $('.block-faq li.question-line>a').on('click', function (e) {
        e.preventDefault();

        var speed = 300;
        var element = $(this).parent();

        if (!element.hasClass('open')) {
            element.addClass('open');
            element.find('.answer').slideDown(speed);
        } else {
            element.removeClass('open');
            element.find('.answer').slideUp(speed);
        }
    });

  //gmapLoaded();

})(jQuery);

function initMap2()
{
    if ($('body.pwa').length) {
        window.initProgram();
    }
}

function initBookingForm(paramsData)
{
    var formElementSelector = 'div.booking-form .block-estimate-sticky.local';
    var formElement = $(formElementSelector);

    spinWaiting(formElementSelector, true);

    $.post($("#base_route").val() + "/_ajax/resetInstance/", {}, function (data) {
        $.ajax({
            url: $('#base_route').attr('value') + "/booking_form/bookingForm",
            type: 'GET',
            data: paramsData
        }).done(function (recivedData) {
            formElement.html(recivedData);
            if ($('.block-reviews').length === 1) {
                $('.header-reviews-overview').html($('.block-reviews').html());
                $('.header-reviews-overview .note-and-comments').show();
            }
            spinWaiting(formElementSelector, false);
            formElement.css('display', 'block');
            setTimeout(function () {
                $('select:not(#id_agence_depart):not(#id_agence_retour)').dropdown({
                    maxItems: 5
                }).dropdown({
                    maxItems: 5
                });
                setTimeout(function () {
                    $('select').each(function () {
                        if ($(this).parent().find('.form-element-dropdown').length > 1) {
                            $(this).parent().find('.form-element-dropdown:last-child').remove();
                        }
                    });
                }, 100);
            }, 100);

            if (
                $('.booking-form .form-element.select.agence_depart, ' +
                    '.booking-form .form-element.select.agence_retour').length > 0
            ) {
                $(
                    '.booking-form .form-element.select.agence_depart .form-element-dropdown'
                ).each(function (cpt) {
                    if (cpt === 0) {
                        $(this).show();
                    }
                    cpt++;
                });
                $(
                    '.booking-form .form-element.select.agence_retour .form-element-dropdown'
                ).each(function (cpt) {
                    if (cpt === 0) {
                        $(this).show();
                    }
                    cpt++;
                });
            }

            $('.form-element.select.agence_retour.disabled div:last-child').addClass('hidden');

        }).fail(function (recivedData) {
            //Nothing done
        }).always(function (recivedData) {
            formElement.css('height', 'inherit');
            spinWaiting(formElementSelector, false);
        });
    });
}

jQuery(document).ready(function ($) {

    $('select').dropdown({
        maxItems: 5
    });

    $(document).click(function (event) {
        if ($(window).width() < 1022 && $('.block-nav-mobile.open').length &&
        (
        ($(event.target).hasClass('burger') || $(event.target).hasClass('block-top-mobile') || $(event.target).hasClass('col-md-12') || ($(event.target).hasClass('container') && $(event.target).find('span.burger').length))
         ||
        $(event.target).hasClass('--wrapper')
        )
        ) {
            $('section#burger-menu-background').trigger('click');
        }
    });

    $(document).on('click','.form-element-dropdown a',function () {

        var index = 1;

        $(this).parent().find('li').each(function () {
            $(this).removeAttr('selected').attr('data-index', index);
            index++;
        });

        $(this).parent().find("ul li:contains(" + $(this).text() + ")").attr('selected', 'selected');

        if ($(this).parent().parent().hasClass('age-permis') || $(this).parent().parent().hasClass('tranche-age')) {
            $('.popin-content').scrollTop($('.popin-content')[0].scrollHeight);
        }

        var index = parseInt($(this).parent().find('ul li[selected="selected"]').attr('data-index'));

        $(this).parent().find('ul').animate({
            scrollTop: (index - 2) * 20
        }, 5, function () {
        });
    });

});

(function ($) {
    var body = $('body');

    var base_route = $("#base_route").val();

    $('div.topbar.rwd').each(function () {
        var $currentNode = $(this);
        $.post(base_route + "/_ajax/topBar/", {
        }, function (data) {
            $currentNode.replaceWith(data);
        })
    });

    var $dropdownBtn = $(".dropdown-btn");

    bindOverDropdown();
    bindOutDropdown();

    function bindOverDropdown()
    {
        $dropdownBtn.bind("mouseenter", onNavMouseOver);
        // $dropdown.bind("mouseover", onNavMouseOver);
    }

    function bindOutDropdown()
    {
        $dropdownBtn.bind("mouseleave", onNavMouseOut);
    }

    function onNavMouseOver()
    {
        var $currentDropdown = $(this).parent().find(".dropdown");
        $currentDropdown.stop(true, true).fadeIn();
    }

    function onNavMouseOut()
    {
        var $currentDropdown = $(this).parent().find(".dropdown");
        $currentDropdown.stop(true, true).fadeOut();
    }

    function manageKnowMoreElements()
    {
        $('a.know-more[title]').each(function () {
            // pour accepter un contenu html
            var title = $(this).attr('title');
            $(this).tooltip({
                track: true,
                content: title
            });
            $(this).click(function (e) {
                e.stopPropagation();
                e.preventDefault();
            });
        });

        $('.know-more[data-content]').each(function () {
            $(this).hover(function (e) {
                if ($(this).data('content')) {
                    var tooltipBox = $('<div class="tooltip">' +
                        '<p>' +
                        $(this).data('content') +
                        '</p>' +
                        '</div>');

                    tooltipBox.appendTo($(this)).show();
                    $(this).on('mouseleave', function () {
                        $(this).find('.tooltip')
                            .remove();
                    });
                }
            });
            $(this).click(function (e) {
                e.stopPropagation();
                e.preventDefault();
            });
        });
    }


    $(document).click(function (e) {
        if (!$(e.target).closest('.main-nav').length && !$(e.target).closest('.menu-toggle').length) {
            $('.main-nav').removeClass('open');
        }
    });

    //==========================================================================
    // Main nav
    //==========================================================================

    function mobileSectionMainResize($el)
    {
        if ($(this).width() >= 992) {
            // supprime les hauteurs fixées en js
            $('ul.main-menu , ul.main-menu ul.mobile-submenu ').height('');
        } else {
            $('ul.main-menu , ul.main-menu ul.mobile-submenu ').each(function () {
                // sauvegarde la hauteur de tous les menus et sous-menus
                if (!$.isNumeric($(this).data("memoHeight"))) {
                    $(this).data("memoHeight", $(this).height());
                }
            });

            if (typeof ($el) !== 'object') {
                $el = $('ul.main-menu');
            }
            var elh = $el.data("memoHeight");
            $el.height(elh);
            var elt = $el.position().top;
            var smt = $('section.main').position().top;
            // retaille tout les UL pour voir tous les items du menu visible mais pas plus (scroll)
            $('ul.main-menu, ul.main-menu ul.mobile-submenu').height(elh);
            // retaille section.main pour pouvoir scroller le menu sur mobile mais pas plus
            $('section.main').height(elh + elt - smt);
        }
    }

    $(window).resize(function (e) {
        if ($(this).width() >= 992) {
            $('section.main').css('overflow', 'visible');
            $('body').removeClass('mobile-menu-open');
            mobileSectionMainResize();
        }
    });

    $('.menu-toggle').click(function (e) {
        e.preventDefault();
        if (!$('.main-nav').hasClass('open')) {
            $('body').addClass('mobile-menu-open');
            $('.main-nav').addClass('open');
            $('section.main').css('overflow', 'hidden');
            mobileSectionMainResize();
        } else {
            $('body').removeClass('mobile-menu-open');
            $('.main-nav').removeClass('open');
            $('.main-nav .mobile-submenu').removeClass('show');
            $('section.main').css('overflow', 'visible');
        }
    });

    $('.has-submenu > a').on('click', function (e) {
        e.preventDefault();
        $(this).siblings('.mobile-submenu').addClass('show');
        mobileSectionMainResize($(this).siblings('.mobile-submenu'));
    });

    $('.mobile-submenu .back').on('click', function (e) {
        e.preventDefault();
        var $actualMenu = $(this).closest('.mobile-submenu');
        $actualMenu.removeClass('show');
        mobileSectionMainResize($actualMenu.parents("ul"));
    });

    $(document).click(function (e) {
        if (!$(e.target).closest('.main-nav').length && !$(e.target).closest('.menu-toggle').length) {
            $('body').removeClass('mobile-menu-open');
            $('.main-nav').removeClass('open');
            $('.main-nav .mobile-submenu').removeClass('show');
            $('section.main').css('overflow', 'visible');
        }
    });

    if ($('.main-menu li.has-submenu').length) {
        var $menu = $('.main-menu');
        $menu.menuAim({
            activate: activateSubmenu,
            deactivate: deactivateSubmenu,
            enter: function () {
            },
            exit: function () {
            },
            exitMenu: function () {
                $menu.find('.megamenu-trigger > span').removeClass('active');
                return true;
            },
            rowSelector: ".has-submenu",
            submenuSelector: "*",
            submenuDirection: "below",
            activationDelay: 250
        });
    }

    function activateSubmenu(row, activeRow)
    {
        row = $(row);
        row.find('> span').addClass('active');

        if (activeRow) {
            row.find('.submenu').show();
        } else {
            row.find('.submenu').slideDown(250);
        }
    }

    function deactivateSubmenu(row, nextRow)
    {
        row = $(row);
        row.find('> span').removeClass('active');

        if (nextRow) {
            row.find('.submenu').hide();
        } else {
            $('.submenu').slideUp(250, function () {
                $('.megamenu-trigger > span').removeClass('active');
            });
        }
    }

    //==========================================================================

    $('.radio-group').each(function () {
        var options = $(this).find('.option');
        var l = options.length;

        var shutEmOff = function () {
            for (var i = 0; i < l; i++) {
                var option = $(options[i]);
                option.removeClass('current');
                option.find('input[type="radio"]').removeAttr('checked');
            }
        }

        for (var i = 0; i < l; i++) {
            var option = $(options[i]);
            var drawedRadio = option.find('span');
            var actualRadio = option.find('input[type="radio"]');

            if (option.hasClass('current')) {
                actualRadio.attr('checked', 'checked');
            }

            + function (drawedRadio, actualRadio) {
                drawedRadio.on('click', function () {
                    var checked = actualRadio.attr('checked');
                    shutEmOff();
                    if (typeof (checked) !== 'undefined') {
                        actualRadio.removeAttr('checked');
                    } else {
                        actualRadio.attr('checked', 'checked');
                    }
                    actualRadio.attr('checked', 'true');
                    actualRadio.parent().addClass('current');
                });
            }(drawedRadio, actualRadio);
        }
    });

    $('.styled-checkbox').each(function () {
        var styledCheckbox = $(this);

        if (styledCheckbox.find('input').prop('checked')) {
            styledCheckbox.addClass('checked');
        } else {
            styledCheckbox.removeClass('checked');
        }

        $(this).find('span').click(function (e) {
            if ($(e.target).hasClass('noclick')) {
                return false;
            }

            var input = styledCheckbox.find('input').first();

            if (input.prop('checked')) {
                styledCheckbox.removeClass('checked');
                input.removeAttr('checked');
                input.prop('checked', false);
                input.trigger('change');
            } else {
                styledCheckbox.addClass('checked');
                input.attr('checked', 'checked');
                input.prop('checked', true);
                input.trigger('change');
            }
        });
    });

    $('.switch-checkbox').each(function () {
        var switchCheckbox = $(this);
        if (switchCheckbox.hasClass('checked')) {
            switchCheckbox.find('input').attr('checked', 'checked');
        }

        var toggleBox = function () {
            var input = switchCheckbox.find('input');
            if (typeof (input.attr('checked')) == 'undefined') {
                input.attr('checked', 'checked');
                switchCheckbox.addClass('checked');
            } else {
                input.removeAttr('checked');
                switchCheckbox.removeClass('checked');
            }
        };

        switchCheckbox.find('span').on('click', toggleBox);
    });

    $('.collapsable-box').each(function () {
        var collapsableBox = $(this);
        collapsableBox.children('div.title').on('click', function () {
            var content = collapsableBox.find('.content')
            if (collapsableBox.hasClass('closed')) {
                collapsableBox.removeClass('closed');
            } else {
                collapsableBox.addClass('closed');
            }
        });
    });

    manageKnowMoreElements();

    $('.slider-bar').each(function () {
        var wrapper = $(this);

        // Creating the bar
        var bar = $('<div class="bar">');
        wrapper.append(bar);

        // Grabbing the settings
        var min = wrapper.data('min');
        var max = wrapper.data('max');
        var step = wrapper.data('step');
        var range = wrapper.data('range');

        if (
            typeof (min) !== 'undefined' ||
            typeof (max) !== 'undefined'
        ) {
            var options = {
                min: min,
                max: max
            };

            if (typeof (step) !== 'undefined') {
                options.step = step;
            } else {
                options.step = 1;
            }

            if (typeof (range) !== 'undefined') {
                options.range = true;
                options.values = [options.min, options.min + options.step];
            }


            var n_vals = (options.max - options.min) / options.step + 1;

            var values = $('<ul class="values">');
            var rulers = $('<ul class="rulers">');
            var percentWidth = (100 / n_vals);
            for (var i = 0; i < n_vals; i++) {
                // The "mesure" for the ruler
                rulers.append(
                    $('<li>').html('<span></span>').css({'width': percentWidth + '%'})
                );

                // The value
                values.append(
                    $('<li>').html(i * options.step).css({'width': percentWidth + '%'})
                );
            }

            bar.slider(options);
            wrapper.append(rulers, values);
        }

    });
    var sidebarMap = {
        initMap: function (mapId) {
            var mapElementsDepart = null;
            var mapElementsRetour = null;
            var mapOptions = null;
            var map = null;
            var clientReference = '';
            var clientName = '';
            var marker = null;

            if (mapId !== undefined) {
                mapElementsDepart = $("#" + mapId);
                mapOptions = {
                    // How zoomed in you want the map to start at (always required)
                    zoom: 15,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    // The latitude and longitude to center the map (always required)
                    center: new google.maps.LatLng(mapElementsDepart.attr('data-latitude'), mapElementsDepart.attr('data-longitude'))
                };

                map = new google.maps.Map(document.getElementById(mapId), mapOptions);
                clientReference = $('#client-reference').text();
                clientName = $('#client-name').text();

                // Add Markers
                marker =
                    new google.maps.Marker({
                        position: new google.maps.LatLng(mapElementsDepart.attr('data-latitude'), mapElementsDepart.attr('data-longitude')),
                        map: map,
                        title: 'Agence ' + clientName + ' de ' + mapElementsDepart.attr('data-villeweb'),
                        icon: '../../../images/v3/specifique_client/' + clientReference + '/icons/map-icon.png'
                    })
                ;
                marker.setMap(map);
            } else {
                mapElementsDepart = $("#map_depart");
                mapOptions = {
                    // How zoomed in you want the map to start at (always required)
                    zoom: 15,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    // The latitude and longitude to center the map (always required)
                    center: new google.maps.LatLng(mapElementsDepart.attr('data-latitude'), mapElementsDepart.attr('data-longitude'))
                };

                map = new google.maps.Map(document.getElementById('map_depart'), mapOptions);
                clientReference = $('#client-reference').text();
                clientName = $('#client-name').text();

                // Add Markers
                marker =
                    new google.maps.Marker({
                        position: new google.maps.LatLng(mapElementsDepart.attr('data-latitude'), mapElementsDepart.attr('data-longitude')),
                        map: map,
                        title: 'Agence ' + clientName + ' de ' + mapElementsDepart.attr('data-villeweb'),
                        icon: '../../../images/v3/specifique_client/' + clientReference + '/icons/map-icon.png'
                    })
                ;
                marker.setMap(map);

                if ($("#map_retour").length) {
                    mapElementsRetour = $("#map_retour");

                    mapOptions = {
                        // How zoomed in you want the map to start at (always required)
                        zoom: 15,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        // The latitude and longitude to center the map (always required)
                        center: new google.maps.LatLng(mapElementsRetour.attr('data-latitude'), mapElementsRetour.attr('data-longitude'))
                    };

                    map = new google.maps.Map(document.getElementById('map_retour'), mapOptions);
                    clientReference = $('#client-reference').text();
                    clientName = $('#client-name').text();

                    // Add Markers
                    marker =
                        new google.maps.Marker({
                            position: new google.maps.LatLng(mapElementsRetour.attr('data-latitude'), mapElementsRetour.attr('data-longitude')),
                            map: map,
                            title: 'Agence ' + clientName + ' de ' + mapElementsRetour.attr('data-villeweb'),
                            icon: '../../../images/v3/specifique_client/' + clientReference + '/icons/map-icon.png'
                        })
                    ;
                    marker.setMap(map);
                }
            }
        }
    };

    var vehicleSearch = undefined;
    vehicleSearch = {
        tabs: $('.vehicle-searchform-tabs a'),
        form: $('#vehicle-search'),
        submit: $('.vehicle-searchform-submit'),
        mapIsInit: false,
        init: function () {
            var self = this;

            $('.slider-loc-search').each(function (i, e) {

                $(this)
                    .on('jcarousel:reload jcarousel:create', function () {
                        $('.slider-loc-search').each(function () {

                            var width = $(this).innerWidth();

                            $(this).find('.slider-inner > li').css('width', width + 'px');
                        });
                    })
                    .jcarousel();
            });

            $('.slider-loc-search .bullets .inner')
                .on('jcarouselpagination:active', 'a', function () {
                    $(this).addClass('active');
                })
                .on('jcarouselpagination:inactive', 'a', function () {
                    $(this).removeClass('active');
                })
                .jcarouselPagination();

            if (jQuery().touchwipe) {
                $('.slider-loc-search').touchwipe({
                    wipeLeft: function (e) {
                        e.jcarousel('scroll', '+=1');
                    },
                    wipeRight: function (e) {
                        e.jcarousel('scroll', '-=1');
                    },
                    min_move_x: 20,
                    min_move_y: 20,
                    preventDefaultEvents: false
                });
            }

            self.tabs.click(function (e) {
                e.preventDefault();
                if (!$(this).hasClass('active')) {
                    self.tabs.removeClass('active');
                    $(this).addClass('active');
                }
            });

            self.submit.click(function (e) {
                e.preventDefault();
                self.form.submit();
            });


            $(".select-agency li[data-search]").each(function (e) {
                // initialise pour la recherche sans accent
                $(this).attr('data-search', filterConvert($(this).attr('data-search')));
            });

            $("#search-departure, #search-arrival").keydown(function (e) {
                // invalide la touche entrer dans les champs de filtrage
                if (e.which == 13) {
                    e.preventDefault();
                }
            });

            $("#search-departure, #search-arrival").keyup(function (e) {
                // filtre les agences
                vehicleSearch.filterAgency($(this))
            });

            $('.input-departure, .input-arrival').click(function (e) {
                $("#search-departure, #search-arrival").hide();
                var $selectAgency = $(this).parent('.vehicle-searchform-line').find('.select-agency');
                if (!$selectAgency.hasClass('visible')) {
                    self.openAgenciesList($(this));
                    var $searchInput = $(this).find("#search-departure, #search-arrival");
                    if ($searchInput.length) {
                        $searchInput.show().focus();
                        vehicleSearch.filterAgency($searchInput);
                    }
                } else {
                    self.closeAgenciesList();
                }
            });

            if ($('#vehicle-type:not(.invisible), #drivers-age, #licence-age').length > 0) {
                $('#vehicle-type:not(.invisible), #drivers-age, #licence-age').selectmenu();
            }

            $.extend($.datepicker, {
                _checkOffset: function (inst, offset, isFixed) {
                    return offset
                }
            });

            $(document).click(function (e) {

                var newHeight = $('#loc-search-default-height').attr('data-value');
                if (!$('body.partial-pwa, body.pwa').length) {
                    if (
                        !$(e.target).hasClass('input-departure') &&
                        !$(e.target).hasClass('input-arrival') &&
                        !$(e.target).closest('div').hasClass('input-departure') &&
                        !$(e.target).closest('div').hasClass('input-arrival')
                    ) {
                        $('.loc-search').css('height', $('#loc-search-default-height').attr('data-value') + 'px');
                    }
                }

                if (!$(e.target).closest('.input-departure').length && !$(e.target).closest('.agency-info').length) {
                    $('.select-departure').removeClass('visible');
                    $("#search-departure").hide();
                }

                if (!$(e.target).closest('.input-arrival').length && !$(e.target).closest('.agency-info').length) {
                    $('.select-arrival').removeClass('visible');
                    $("#search-arrival").hide();
                }

                if (!$(e.target).closest('.input-departure').length && !$(e.target).closest('.input-arrival').length && !$(e.target).closest('.agency-info').length) {
                    $('.vehicle-searchform').removeClass('open').removeClass('arrival');
                    $('.vehicle-searchform .agency-info').removeClass('visible');
                    $('body.home .loc-search').removeClass('full-height');
                }

            });

            $(document).ready(function () {
                $(document).click();
            });

            $('.select-agency a').click(function (e) {
                e.preventDefault;
                self.closeAgenciesList(e);
                var value = $(this).find('.name').text();
                if ($(this).closest('.vehicle-searchform-line').find('.input-departure').length == 1) {
                    var val2 = $('.vehicle-searchform-line .input-arrival .agency-value').text();
                } else {
                    if ($(this).closest('.vehicle-searchform-line').find('.input-arrival').length == 1) {
                        var val2 = $('.vehicle-searchform-line .input-departure .agency-value').text();
                    }
                }

                $(this).closest('.vehicle-searchform-line').find('.agency-value').text(value);
                //one way trip status update required :
                var elem = null;
                if ($('.form-context input[name="one_way_trip"]').length == 1) {
                    elem = $('.form-context input[name="one_way_trip"]');
                    if (value != val2) {
                        elem.attr('value', '1');
                    } else {
                        elem.attr('value', '0');
                    }
                } else {
                    elem = $('.form-context .one-way-trip');
                    if (value != val2) {
                        elem.text('1');
                    } else {
                        elem.text('0');
                    }
                }
            });
        },
        openAgenciesList: function (trigger) {

            var self = this;
            if ($(trigger).parent('.vehicle-searchform-line').find('.input-arrival.disabled').length == 0) {
                $(trigger).parent('.vehicle-searchform-line').find('.select-agency').addClass('visible');
                $('.vehicle-searchform .agency-info').addClass('visible');

                if ($('.select-agency.select-departure').hasClass('visible')) {
                    $('.vehicle-searchform .agency-info .agency-hours-ctn.departure').show();
                    $('.vehicle-searchform .agency-info .agency-hours-ctn.return').hide();
                    $('.vehicle-searchform').removeClass('arrival');
                } else if ($('.select-agency.select-arrival').hasClass('visible')) {
                    $('.vehicle-searchform .agency-info .agency-hours-ctn.return').show();
                    $('.vehicle-searchform .agency-info .agency-hours-ctn.departure').hide();
                    if (matchMedia('(max-width: 992px)').matches) {
                        $('.vehicle-searchform').addClass('arrival');
                    }
                }

                var newHeight = $('.loc-search').height() + $('div[id^="agency-info-"]').height() + $('.add-message').height() + 20;
                $('.loc-search').css('height', newHeight + 'px');

                $('.vehicle-searchform').addClass('open');

                if (self.mapIsInit == false) {
                    self.initMap();
                }
                $('body.home .loc-search').addClass('full-height');
            }
        },
        closeAgenciesList: function (e) {

            if (!$('body.partial-pwa, body.pwa').length) {
                var newHeight = $('#loc-search-default-height').attr('data-value');
                $('.loc-search').css('height', newHeight + 'px');
            }

            var self = this;

            $('.select-departure, .select-arrival').removeClass('visible');
            $('.vehicle-searchform').removeClass('open').removeClass('arrival');
            $('.vehicle-searchform .agency-info').removeClass('visible');

            $('body.home .loc-search').removeClass('full-height');
        },
        initMap: function () {
        },
        filterAgency: function ($element) {
            var $selectAgency;
            var strfiltre = filterConvert($element.val());

            $selectAgency = $element.parents('.vehicle-searchform-line').find('.select-agency');
            $("#info_agence_depart_none,#info_agence_retour_none").hide();
            if (strfiltre.length > 0) {
                $selectAgency.find('li[data-search]').hide();
                $selectAgency.find('li[data-search*="' + strfiltre + '"]').show();
                $selectAgency.find('li[data-search-cp^="' + strfiltre + '"]').show();
            } else {
                $selectAgency.find('li[data-search]').show();
            }
            $selectAgency.find("#info_agence_depart_none, #info_agence_retour_none").toggle(!$selectAgency.find('li[data-search]:visible').length);
        }
    };


    var agenciesList = {
        mapEl: $('.agencies-map .gmap'),
        map: null
    };

    var eventPage = {
        mapEl: $('.location-map .mapCanvas'),
        init: function () {
            this.initMap();


        },
        initMap: function () {

            var mapOptions = {
                zoom: parseInt($('#agency-zoom').attr('data-zoom')),
                scrollwheel: false,
                center: new google.maps.LatLng($('.latlong .lat').text(), $('.latlong .long').text())
            };
            var mapElement = this.mapEl[0];
            var map = new google.maps.Map(mapElement, mapOptions);

            var marker = new google.maps.Marker({
                position: new google.maps.LatLng($('.latlong .lat').text(), $('.latlong .long').text()),
                title: "Lieu de l'évènement",
                animation: google.maps.Animation.DROP,
                icon: '/images/v3/specifique_client/' + $('#client-reference').text() + '/icons/map_icon_black.png'
            });
            marker.setMap(map);
        }
    };

    var agencyPage = {
        mapEl: $('.agency-widget .location-map .mapCanvas'),
        init: function () {
            this.initMap();

            // init feedbacks Masonry
            if ($('#feedbacks-masonry').length) {
                var msnry = new Masonry('#feedbacks-masonry', {
                    itemSelector: '.feedbacks-masonry-item',
                    transitionDuration: 0
                });
            }


        },
        initMap: function () {
            if ($('div.location-map').length) {
                var mapOptions = {
                    zoom: parseInt($('#agency-zoom').attr('data-zoom')),
                    scrollwheel: false,
                    center: new google.maps.LatLng($('.latlong .lat').text(), $('.latlong .long').text())
                };
                var mapElement = this.mapEl[0];
                var map = new google.maps.Map(mapElement, mapOptions);

                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng($('.latlong .lat').text(), $('.latlong .long').text()),
                    title: $('.page-title-ctn #agenceName').text(),
                    animation: google.maps.Animation.DROP,
                    icon: '../../../images/v3/specifique_client/' + $('#client-reference').text() + '/icons/map-icon.png'
                });
                marker.setMap(map);
            }
        }
    };
    var singleVehicle = {
        init: function () {
            $('.slider-vehicle-images').each(function (i, e) {
                $(this)
                    .on('jcarousel:reload jcarousel:create', function () {
                        $('.slider-vehicle-images').each(function () {

                            var width = $(this).innerWidth();

                            $(this).find('.slider-inner > li').css('width', width + 'px');
                        });
                    })
                    .jcarousel();
            });

            $('.slider-vehicle-images .bullets .inner')
                .on('jcarouselpagination:active', 'a', function () {
                    $(this).addClass('active');
                })
                .on('jcarouselpagination:inactive', 'a', function () {
                    $(this).removeClass('active');
                });

            if ($.jcarouselPagination) {
                $('.slider-vehicle-images .bullets .inner').jcarouselPagination();
            }

            if (jQuery().touchwipe) {
                $('.slider-vehicle-images').touchwipe({
                    wipeLeft: function (e) {
                        e.jcarousel('scroll', '+=1');
                    },
                    wipeRight: function (e) {
                        e.jcarousel('scroll', '-=1');
                    },
                    min_move_x: 20,
                    min_move_y: 20,
                    preventDefaultEvents: false
                });
            }
        }
    };

    var vehicleList = {
        init: function () {
            $('.slider-vehicle-images').each(function (i, e) {
                $(this).on('jcarousel:reload jcarousel:create', function () {

                    $('.slider-vehicle-images').each(function () {

                        var width = $(this).innerWidth();

                        $(this).find('.slider-inner > li').css('width', width + 'px');
                    });
                })
                    .jcarousel();
            });

            $('.slider-vehicle-images .bullets .inner')
                .on('jcarouselpagination:active', 'a', function () {
                    $(this).addClass('active');
                })
                .on('jcarouselpagination:inactive', 'a', function () {
                    $(this).removeClass('active');
                });

            if ($.jcarouselPagination) {
                $('.slider-vehicle-images .bullets .inner').jcarouselPagination();
            }

            if (jQuery().touchwipe) {
                $('.slider-vehicle-images').touchwipe({
                    wipeLeft: function (e) {
                        e.jcarousel('scroll', '+=1');
                    },
                    wipeRight: function (e) {
                        e.jcarousel('scroll', '-=1');
                    },
                    min_move_x: 20,
                    min_move_y: 20,
                    preventDefaultEvents: false
                });
            }

            $('.moar-kilometers-trigger').click(function (e) {
                e.preventDefault();

                $(this).toggleClass('open');
                $('.moar-kilometers').toggle();
            });

            if ($('#drivers-age-filter, #licence-age-filter').length > 0) {
                $('#drivers-age-filter, #licence-age-filter').selectmenu();
            }

            $('.button-search-options').click(function (e) {
                e.preventDefault();
                $(this).toggleClass('open');
                $('.loc-search-edit').toggleClass('invisible');
            });

        }
    };



    if ($('.loc-search').length > 0) {
        if (body.hasClass('page-vehicles') || body.hasClass('page-vehicle')) {
            vehicleList.init();
        }

        if (body.hasClass('home') && $('.form-context').length) {
            //Chargement asynchrone du formulaire de réservation
            var method = 'POST;'
            if ($('.form-context .method').length === 0 || $('input[name="method"]').val() === 'GET') {
                method = 'GET';
            }
            $.ajax({
                url: $('#base_route').attr('value') + "/booking_form/bookingForm",
                type: method,
                data: getFormParameters()
            }).done(function (data) {
                $('.form-container .inner-form').html(data);

                vehicleSearch.init();

                $('#boutonValider.loader').click(function () {
                    var message = '';
                    if (this.hasAttribute('data-loader-message')) {
                        message = $(this).attr('data-loader-message');
                    }
                    showLoader(message);
                });
                setFormDepartureArrival();

                manageKnowMoreElements();

                $('a.my-demand').click(function () {
                    if ($(this).hasClass('open')) {
                        $('.loc-search-edit').fadeIn('slow');
                        $('#vehicle-searchform').toggleClass('invisible', false);
                    } else {
                        $('.loc-search-edit').fadeOut('slow');
                        $('#vehicle-searchform').toggleClass('invisible', true);
                    }
                    $(this).toggleClass('open');
                    $('.loc-search-edit').each(function () {
                        modifieEntetesFixesEtFlottants();
                    });
                });

            }).fail(function (data) {
                //Nothing done
            }).always(function (data) {
                setFormDepartureArrival();

                hideLoader();
            });
        } else {
            vehicleSearch.init();
        }
    } else if (body.hasClass('page-agencies-list')) {
        //agenciesList.init();
    } else if (body.hasClass('page-agency') || body.hasClass('page-event-list')) {
        //agencyPage.init();
        $('.collapsable-box.has-top-sep.feedback-agency').removeAttr('style');
    } else if (body.hasClass('page-vehicle')) {
        singleVehicle.init();
    } else if (body.hasClass('page-vehicles') || body.hasClass('page-vehicle')) {
        vehicleList.init();
    }

    if (body.hasClass('rentiz-step-vehicle')) {
        singleVehicle.init();
    }

    var jcarousel = $('.jcarousel');
    var autostart = false;
    var carouselTimer = 5;

    jcarousel
        .on('jcarousel:reload jcarousel:create', function () {
            var width = jcarousel.innerWidth();

            if ($('#adaptative-width').attr('data-disable') != 'true') {
                if (width >= 600) {
                    width = width / 3;
                } else if (width >= 350) {
                    width = width / 2;
                }
                jcarousel.jcarousel('items').css('width', width + 'px');
            }
        });

    if (jcarousel.length) {
        jcarousel.jcarousel({
            wrap: 'circular'
        });
    }

    jcarousel.each(function () {
        if ($(this).hasClass('vehicules')) {
            carouselTimer = $('#vehicles-carousel-timer').text();
        }

        $(this).jcarouselAutoscroll({
            interval: carouselTimer,
            target: '+=1',
            autostart: autostart
        });


        $('.jcarousel-control-prev')
            .jcarouselControl({
                target: '-=1',
                carousel: $(this)
            });

        $('.jcarousel-control-next')
            .jcarouselControl({
                target: '+=1',
                carousel: $(this)
            });

    });


    jcarousel.touchwipe({
        wipeLeft: function () {
            jcarousel.jcarousel('scroll', '+=1');
        },
        wipeRight: function () {
            jcarousel.jcarousel('scroll', '-=1');
        },
        min_move_x: 20,
        min_move_y: 20,
        preventDefaultEvents: false
    });

    if ($('.jcarousel-pagination').length) {
        $('.jcarousel-pagination')
            .on('jcarouselpagination:active', 'a', function () {
                $(this).addClass('active');
            })
            .on('jcarouselpagination:inactive', 'a', function () {
                $(this).removeClass('active');
            })
            .on('click', function (e) {
                e.preventDefault();
            })
            .jcarouselPagination({
                perPage: 1,
                item: function (page) {
                    return '<a href="#' + page + '">' + page + '</a>';
                },
            carousel: jcarousel
            });
    }

    var feedbackcarousel = $('.feedback-jcarousel');
    var carouselTimer = 5;

    if (jcarousel.length > 0) {
        feedbackcarousel.on('jcarousel:reload jcarousel:create', function () {
            feedbackcarousel.jcarousel('items').width(feedbackcarousel.innerWidth());
        }).jcarousel({
            wrap: 'circular'
        }).jcarouselAutoscroll({
            interval: carouselTimer,
            target: '+=1',
            autostart: false
        });

        $('.feedback-slider-prev')
            .jcarouselControl({
                target: '-=1',
                carousel: feedbackcarousel
            });

        $('.feedback-slider-next')
            .jcarouselControl({
                target: '+=1',
                carousel: feedbackcarousel
            });

        feedbackcarousel.touchwipe({
            wipeLeft: function () {
                feedbackcarousel.jcarousel('scroll', '+=1');
            },
            wipeRight: function () {
                feedbackcarousel.jcarousel('scroll', '-=1');
            },
            min_move_x: 20,
            min_move_y: 20,
            preventDefaultEvents: false
        });
    }

    if ($('.custom-select').length > 0) {
        $('.custom-select').selectmenu({
            create: function (event, ui) {
                var prefix = $(event.target).attr('data-prefix');

                if (typeof prefix !== 'undefined') {
                    $('#' + $(event.target).attr('id') + '-button').find('.ui-selectmenu-text').prepend('<span class="prefix">' + prefix + '</span>');
                }
            },
            select: function (event, ui) {
                var prefix = $(event.target).attr('data-prefix');


                if (typeof prefix !== 'undefined') {
                    $('#' + $(event.target).attr('id') + '-button').find('.ui-selectmenu-text').prepend('<span class="prefix">' + prefix + '</span>');
                }

                if ($(this).attr('id') == 'vehicles-sort-agence') {
                    window.location = $(event.target).val();
                }

                if ($(this).attr('id') == 'vehicles-sort') {
                    window.location = $(event.target).val();
                }

                if ($('body.page-vehicles').length === 0) {
                    window.location = $(event.target).val();
                }

                if ($(event.target).attr('id') != 'vehicles-sort-vehicle-type' && $(event.target).attr('id') != 'vehicles-sort-type') {
                    if ($(event.target).val() == 'pertinence') {
                        var sortedVehicles = $('.vehicle-singles .vehicle-single').sort(function (a, b) {
                            var rep = parseFloat($(b).attr('data-pertinence')) - parseFloat($(a).attr('data-pertinence'));
                            return rep;
                        });
                    } else if ($(event.target).val() == 'desc') {
                        var sortedVehicles = $('.vehicle-singles .vehicle-single').sort(function (a, b) {
                            // tri sur le prix et à defaut sur la position. (toujours les prix en premier)
                            var posa = parseFloat($(a).attr('data-position')) || 0.0;
                            var posb = parseFloat($(b).attr('data-position')) || 0.0;
                            var pricea = parseFloat($(a).attr('data-price')) || 0.0;
                            var priceb = parseFloat($(b).attr('data-price')) || 0.0;
                            var rep = 0;
                            if (pricea !== 0.0 && priceb !== 0.0) {
                                rep = priceb - pricea;
                            } else if (pricea !== 0.0) {
                                rep = -1;
                            } else if (priceb !== 0.0) {
                                rep = 1;
                            } else {
                                rep = posb - posa;
                            }
                            return rep;
                        });
                    } else {
                        var sortedVehicles = $('.vehicle-singles .vehicle-single').sort(function (a, b) {
                            // tri sur le prix et à defaut sur la position. (toujours les prix en premier)
                            var posa = parseFloat($(a).attr('data-position')) || 0.0;
                            var posb = parseFloat($(b).attr('data-position')) || 0.0;
                            var pricea = parseFloat($(a).attr('data-price')) || 0.0;
                            var priceb = parseFloat($(b).attr('data-price')) || 0.0;
                            var rep = 0;
                            if (pricea !== 0.0 && priceb !== 0.0) {
                                rep = pricea - priceb;
                            } else if (pricea !== 0.0) {
                                rep = -1;
                            } else if (priceb !== 0.0) {
                                rep = 1;
                            } else {
                                rep = posa - posb;
                            }
                            return rep;
                        });
                    }

                    $.each(sortedVehicles, function (index, element) {
                        $('.vehicle-singles').append($(element));
                    });
                } else {
                    var idType = $(event.target).val();
                    var text = $('#vehicles-sort.filter option[value="' + idType + '"] ').text();

                    if (idType == 'all') {
                        $('.vehicle-single').each(function () {
                            $(this).fadeIn(500);
                        });
                    } else {
                        $('.vehicle-single').each(function () {
                            var elem = $(this).find('.prixOnline');
                            var selector = 'data-idtypevehicule';
                            if (!elem.length) {
                                elem = $(this);
                                selector = 'data-type';
                            }

                            if (elem.attr(selector) != idType) {
                                $(this).fadeOut(500)
                            } else {
                                $(this).fadeIn(500);
                            }
                        });

                        if ($('#sort-selection-old-behaviour').length > 0) {
                            setTimeout(function () {
                                if ($('.vehicle-single:visible').length == 0) {
                                    $('#vehicles-sort-price-button').addClass('grayed').css('pointer-events', 'none');
                                } else {
                                    $('#vehicles-sort-price-button').removeClass('grayed').css('pointer-events', 'all');
                                }
                            }, 700);
                        }
                    }



                    if ($('.vehicle-single[data-type="' + idType + '"]').length == 0) {
                        $('.not-found-msg').addClass('visible').removeClass('invisible');
                        $('.not-found-msg span').text(text);
                    } else {
                        $('.not-found-msg').removeClass('visible').addClass('invisible');
                    }
                }
            }
        });
    }

    if ($(".select-button.form-activated").length && ($('body').hasClass('page-vehicle') || $('body').hasClass('page-vehicles'))) {
        $(".select-button.form-activated").click(function () {
            doQuotationButtonAction($(this));
        });
        performAjaxQuotation($(".select-button.form-activated"));
    }

    //Fiche promotion
    if ($(".select-button.code-promo.arrow-button").length && $('body').hasClass('page-promo-list')) {
        $(".select-button.code-promo.arrow-button").click(function () {
            if ($('#scroll-to-form').text() != '1') {
                doQuotationButtonAction($(this));
            }
        });
        performAjaxQuotation($(".select-button.code-promo.arrow-button"));
    }

    //Fiche évenement
    if ($(".select-button.arrow-button").length && $('body').hasClass('page-event-list')) {
        $(".select-button.arrow-button").click(function () {
            if ($('#scroll-to-form').text() != '1') {
                doQuotationButtonAction($(this));
            }
        });
        performAjaxQuotation($(".select-button.arrow-button"));
    }

    //========================================================
    // Tabs
    //========================================================

    var tabsSelect = undefined;
    tabsSelect = {
        triggerList: $('.tab-triggers'),
        init: function () {
            if ($('body.calculateur').length) {
                var self = this;

                self.triggerList.find('> li > a').click(function (e) {
                    e.preventDefault();
                    $(this).closest('.tab-triggers').find('li').removeClass('active');
                    $(this).parent('li').addClass('active');
                    self.switchTab($(this));
                });
            }
        },
        switchTab: function (trigger) {
            if ($('body.calculateur').length) {
                var self = this;
                var tabsParent = trigger.closest('.tab-triggers').attr('data-target');
                var tabIndex = trigger.attr('data-index');

                $(tabsParent).find('div.page-tab').hide();
                faqList.resetLists();
                calcList.resetLists();
                $(tabsParent).find('div.page-tab[data-index="' + tabIndex + '"]').fadeIn(600);
            }
        }
    }

    //========================================================
    // CLACULATEUR
    //========================================================

// presentation en accordeon

    $(".accordeon").children('.itemAccordeon').each(function () {
        // on les ferme tous
        $(this).removeClass('active');
        $(this).children('div').slideUp(0);
        // lors d'un click sur le titre
        $(this).find('.titreclick').click(function () {
            // memorise mon itemAccordeon
            var itemAccordeon = $(this).parents(".itemAccordeon").last();
            // memorise mon etat active ou non
            var active = $(itemAccordeon).hasClass('active');
            // on ferme les items actifs
            $(this).parents('.accordeon').children('.itemAccordeon.active').each(function () {
                $(this).removeClass('active');
                $(this).children('div').slideUp({duration: 300});
            });
            // on active si besoin mon propre itemAccordeon
            if (!active) {
                $(itemAccordeon).addClass('active');
                $(itemAccordeon).children('div').slideDown({duration: 300});
            }
        });
    });

    //========================================================
    // FAQ
    //========================================================

    var faqList = undefined;
    faqList = {
        list: $('.faq-content'),
        listItems: $('.faq-content li'),
        itemTitle: $('.faq-content .question'),
        init: function () {
            var self = this;

            self.itemTitle.click(function (e) {
                e.preventDefault();
                self.switchItem($(this));
            });
        },
        switchItem: function (item) {
            var self = this;

            if (!item.closest('li').hasClass('open')) {
                self.listItems.removeClass('open');
                item.closest('li').addClass('open');
            }
        },
        resetLists: function () {
            var self = this;

            self.listItems.removeClass('open');

            self.list.each(function (i, e) {
                $(this).find('li:first-child').addClass('open');
            });
        }
    }

    if (body.hasClass('page-faq')) {
        faqList.init();
    }
    //tabsSelect.init();

    //========================================================
    //
    //========================================================

    if (body.hasClass('page-agencies-list') || body.hasClass('page-promo-list')) {
        if ($('#vehicle-type-select, #departure-city-select').length > 0) {
            $('#vehicle-type-select, #departure-city-select').selectmenu({
                change: function (event, data) {
                    if (data.item.value !== undefined) {
                        window.location = data.item.value;
                    }
                }
            });
        }

        $('#promo-single-get').click(function (e) {
            e.preventDefault();
            $(this).fadeOut();
            $('.agency-search-ctn').addClass('open');
        });

        $('#moar-checkbox').click(function (e) {
            if (this.checked) {
                $('.additional-options').fadeIn();

                if ($(window).width() < 992) {
                    $('.additional-options').css('width', $('#vehicle-search').width() + 'px');
                    $('.additional-options').css('position', 'absolute').css('top', '1180px');
                    $('#boutonValider').css('position', 'relative').css('top', '42%');
                    $('#vehicle-searchform').css('height', '530px');
                    $('#vehicle-search').css('height', '530px');
                }

                if ($(window).width() < 768 && $(window).width() > 490) {
                    if ($('#moar-checkbox:checked').length) {
                        $('.additional-options').css('top', '1120px');
                        $('#vehicle-search').css('height', '530px');
                        $('#vehicle-searchform').css('height', '530px');
                        $('#boutonValider').css('top', '42%');
                    }
                }

                if ($(window).width() < 490) {
                    var pos = $('#vehicle-search').offset();
                    $('.additional-options').css('top', ($('.vehicle-searchform-ctn').height() + pos.top + 15) + 'px');
                }

                if ($(window).width() < 483) {
                    if ($('#moar-checkbox:checked').length) {
                        $('#vehicle-search').css('height', '584px');
                        $('#vehicle-searchform').css('height', '592px');
                        $('#boutonValider').css('top', '49%');
                    }
                }
            } else {
                $('.additional-options').fadeOut();
                if ($(window).width() < 992) {
                    $('#vehicle-searchform').removeAttr('style');
                    $('#vehicle-search').removeAttr('style');
                }
            }
        });
    }

    if (body.hasClass('page-account') || body.hasClass('page-wizard-personal-infos')) {
        if ($(window).width() > 991) {
            $('#jour_naissance_day, #jour_naissance_month, #jour_naissance_year, #tiers_jour_naissance_day, #tiers_jour_naissance_month, #tiers_jour_naissance_year').selectmenu({width: 68}).each(function () {
                $(this).selectmenu("menuWidget").addClass("selectmenuoverflow");
            });
            $('#obtention_permis_day, #obtention_permis_month, #obtention_permis_year, #tiers_obtention_permis_day, #tiers_obtention_permis_month, #tiers_obtention_permis_year').selectmenu({width: 68}).each(function () {
                $(this).selectmenu("menuWidget").addClass("selectmenuoverflow");
            });
            $('#tiers_jour_naissance_conducteur_day, #tiers_jour_naissance_conducteur_month, #tiers_jour_naissance_conducteur_year,#tiers_jour_naissance_add_day, #tiers_jour_naissance_add_month, #tiers_jour_naissance_add_year, #tiers_obtention_permis_conducteur_day, #tiers_obtention_permis_conducteur_month, #tiers_obtention_permis_conducteur_year, #tiers_obtention_permis_add_day, #tiers_obtention_permis_add_month, #tiers_obtention_permis_add_year').selectmenu({width: 68}).each(function () {
                $(this).selectmenu("menuWidget").addClass("selectmenuoverflow");
            });
        } else {
            $('#jour_naissance_day, #jour_naissance_month, #jour_naissance_year, #tiers_jour_naissance_day, ' +
                '#tiers_jour_naissance_month, #tiers_jour_naissance_year')
                .addClass('lrStyled')
            ;
            $('#obtention_permis_day, #obtention_permis_month, #obtention_permis_year, #tiers_obtention_permis_day, ' +
                '#tiers_obtention_permis_month, #tiers_obtention_permis_year')
                .addClass('lrStyled')
            ;
            $('#tiers_jour_naissance_conducteur_day, #tiers_jour_naissance_conducteur_month, ' +
                '#tiers_jour_naissance_conducteur_year,#tiers_jour_naissance_add_day, #tiers_jour_naissance_add_month, ' +
                '#tiers_jour_naissance_add_year, #tiers_obtention_permis_conducteur_day, ' +
                '#tiers_obtention_permis_conducteur_month, #tiers_obtention_permis_conducteur_year, ' +
                '#tiers_obtention_permis_add_day, #tiers_obtention_permis_add_month, #tiers_obtention_permis_add_year')
                .addClass('lrStyled')
            ;
        }

        $('#tiers_statut_societe').selectmenu({width: 140});
        $('#day-select, #month-select, #year-select').selectmenu();
        $('#statut_societe').selectmenu();

        $('#obtention_permis_day, #obtention_permis_month, #obtention_permis_year, #tiers_obtention_permis_day,' +
            '#tiers_obtention_permis_month, #tiers_obtention_permis_year').click(
                function (e) {
                    return false;
                }
            )
        ;
    }

    if (body.hasClass('page-wizard-personal-infos') && $(window).width() > 991) {
        if ($('#day-select, #month-select, #year-select').length > 0) {
            $('#day-select, #month-select, #year-select').selectmenu();
        }
    } else {
        if ($(window).width() < 992) {
            $('#day-select, #month-select, #year-select').addClass('lrStyled');
        }
    }

    if (jQuery().fancybox) {
        $(".fancybox").fancybox();
    }

    function doQuotationButtonAction(button)
    {
        if ($('#spinner-script-url').text() != '') {
            loadJS($('#spinner-script-url').text());
        }

        $.post($("#base_route").val() + "/_ajax/resetInstance/", {
        }, function (data) {
        });

        if ($('.form-context').length) {
            var method = 'POST';
            if ($('.form-context .method').length == 0 || $('input[name="method"]').val() == 'GET') {
                method = 'GET';
            }

            $.ajax({
                url: $('#base_route').attr('value') + "/booking_form/bookingForm",
                type: method,
                data: getFormParameters()
            }).done(function (data) {
                if ($('body').hasClass('page-event-list') && $('div.location-map').length && $('.mapCanvas').find('div').length == 0) {
                    eventPage.init();
                }

                $(' .inner-form').html(data);

                vehicleSearch.init();

                $('#boutonValider.loader').click(function () {
                    var message = '';
                    if (this.hasAttribute('data-loader-message')) {
                        message = $(this).attr('data-loader-message');
                    }
                    showLoader(message);
                });
                setFormDepartureArrival();

                manageKnowMoreElements();

                if ($(".select-button.form-activated").length) {
                    button.parent().attr('action', '#');
                    $(".select-button.form-activated.invisible").fadeIn('slow').removeClass('invisible');
                    $("html, body").animate({scrollTop: 0}, 'slow');
                    $('a.my-demand').removeClass('invisible');
                    $('.top-form-controls').removeClass('invisible');
                    $('#vehicle-searchform, .loc-search.loc-search-edit').fadeIn('slow').removeClass('invisible');
                    $('select[name="id_categorie_vehicules"] option').removeAttr('selected');
                    $('select[name="id_categorie_vehicules"] option[value="' + button.attr('data-id-categorie-vehicule') + '"]').attr('selected', 'selected');
                    if (button.hasClass('must-disappear')) {
                        button.addClass('invisible').fadeOut('slow');
                    }

                    $('a.my-demand').click(function () {
                        if ($(this).hasClass('open')) {
                            $('.loc-search-edit').fadeIn('slow');
                            $('#vehicle-searchform').toggleClass('invisible', false);
                        } else {
                            $('.loc-search-edit').fadeOut('slow');
                            $('#vehicle-searchform').toggleClass('invisible', true);
                        }
                        $(this).toggleClass('open');

                        $('.loc-search-edit').each(function () {
                            modifieEntetesFixesEtFlottants();
                        });
                    });
                } else {
                    var o = null;
                    var top = 0;

                    if ($('.select-button.code-promo.arrow-button').length) {
                        o = $('.select-button.code-promo.arrow-button').offset();
                        top = o.top;
                    } else {
                        o = $('#vehicle-search').offset();
                        top = o.top - 100;
                    }

                    $("html, body").animate({scrollTop: top}, 800);

                    $('.loc-search, #vehicle-searchform').removeClass('invisible').fadeIn('slow');
                    button.fadeOut('slow');
                    button.css('pointer-events', 'none');

                    $('.agency-search-ctn').toggleClass('open');

                    var chrome = /chrome/.test(navigator.userAgent.toLowerCase());
                    var safari = /safari/.test(navigator.userAgent.toLowerCase());
                    var position = '';
                    position = '1120px';

                    if ($('#moar-checkbox:checked').length) {
                        $('.additional-options').fadeIn();
                    }

                    $('#moar-checkbox').click(function () {

                        if ($('#moar-checkbox:checked').length) {
                            $('.additional-options').fadeIn().fadeIn();
                        } else {
                            $('.additional-options').fadeOut();
                            $('#vehicle-type option').removeAttr('selected');
                            $('#vehicle-type option[value="0"]').attr('selected', 'selected');
                            $('#vehicle-type-button span.ui-selectmenu-text').text('Sélectionnez un véhicule');
                            $('#kilometres').val('');
                            $('#kilometres').removeAttr('style').removeClass('error');
                            $('#drivers-age option').removeAttr('selected');
                            $('#drivers-age option[value=""]').attr('selected', 'selected');
                            $('#drivers-age-button span.ui-selectmenu-text').text('Votre âge').removeAttr('style');
                            $('#drivers-age-button').removeClass('error');
                            $('#licence-age-button').removeClass('error');
                            $('#licence-age option').removeAttr('selected');
                            $('#licence-age option[value=""]').attr('selected', 'selected');
                            $('#licence-age-button span.ui-selectmenu-text').text('Années de permis').removeAttr('style');
                        }

                        if ($(window).width() > 992) {
                            $('.additional-options').removeAttr('style');
                            $('#vehicle-searchform').removeAttr('style');
                            $('#vehicle-search').removeAttr('style');
                        }

                        if ($(window).width() < 992) {
                            $('.additional-options').css('width', $('#vehicle-search').width() + 'px');
                            $('.additional-options').css('top', '1180px');
                        }

                        if ($(window).width() <= 768 && $(window).width() > 490) {
                            if ($('#moar-checkbox:checked').length) {
                                if (chrome || safari) {
                                    $('.additional-options').css('top', '1180px');
                                } else {
                                    if ($(window).width() == 768) {
                                        $('.additional-options').css('top', '1180px');
                                    } else {
                                        $('.additional-options').css('top', '1120px');
                                    }
                                }
                                $('#vehicle-search').css('height', '530px');
                                $('#vehicle-searchform').css('height', '530px');
                                $('#boutonValider').css('top', '42%');
                            }
                        }

                        if ($(window).width() < 490) {
                            var pos = $('#vehicle-search').offset();
                            $('.additional-options').css('top', ($('.vehicle-searchform-ctn').height() + pos.top + 15) + 'px');
                        }

                        if ($(window).width() < 483) {
                            if ($('#moar-checkbox:checked').length) {
                                $('#vehicle-search').css('height', '584px');
                                $('#vehicle-searchform').css('height', '592px');
                                $('#boutonValider').css('top', '49%');
                            }
                        }
                    });
                }
            }).fail(function (data) {
                //Nothing done
            }).always(function (data) {
                setFormDepartureArrival();

                hideLoader();
            });
        }
    }

    function performAjaxQuotation(object)
    {
        var scrollToForm = $('#scroll-to-form').text();
        $.ajax({
            url: $('#base_route').val() + "/booking_form/getScrollToForm",
            type: "POST",
            data: {
                scroll_to_form: scrollToForm
            }
        }).done(function (data) {
            var obj = jQuery.parseJSON(data);
            $('#scroll-to-form').text(obj['scroll_to_form']);
            if (obj['scroll_to_form'] == '1') {
                doQuotationButtonAction(object);
            }
        }).fail(function (data) {
        }).always(function (data) {
        });
    }

    function getFormParameters()
    {
        var params = {
            id_type: $('input[name="id_type"]').val(),
            owt_availability: $('input[name="owt_availability"]').val(),
            one_way_trip: $('input[name="one_vay_trip"]').val(),
            display_form_tabs: $('input[name="display_form_tabs"]').val(),
            display_form_tabs_ids: $('input[name="display_form_tabs_ids"]').val(),
            module_name: $('input[name="module_name"]').val(),
            action_name: $('input[name="action_name"]').val(),
            post_params_redirect: $('input[name="post_params_redirect"]').val(),
            current_categorie_type_url: $('input[name="current_categorie_type_url"]').val(),
            contenu_categorie_type_url: $('input[name="contenu_categorie_type_url"]').val(),
            contenu_agence_url: $('input[name="contenu_agence_url"]').val(),
            url_type_vehicules: $('input[name="url_type_vehicules"]').val(),
            url_categorie_vehicules: $('input[name="url_categorie_vehicules"]').val(),
            posted_data: $('.form-context .post-data .data').text(),
            display_mode: 'rwd',
        };


        if ($('input[name="id_agence_depart"]').val() != '') {
            params.id_agence_depart = $('input[name="id_agence_depart"]').val();
        }

        if ($('input[name="id_agence_retour"]').val() != '') {
            params.id_agence_retour = $('input[name="id_agence_retour"]').val();
        }

        return params;
    }

    $.fn.initSideBarMaps = function (mapId) {
        sidebarMap.initMap(mapId);
    }
    $.fn.initEventSingleMap = function () {
        eventPage.initMap();
    }
    $.fn.initVehicleSearch = function () {
        vehicleSearch.initMap();
    }
    $.fn.initAgencySingleMap = function () {
        agencyPage.initMap();
    }
})(jQuery);

if ($('#module_name').val() != 'agences') {
    if (($('#module_name').val() == 'vehicules' && !$('body').hasClass('pwa')) || $('#module_name').val() != 'vehicules') {
        function initMap()
        {
            var body = $('body');
            if (body.hasClass('page-event-list') && $('div.location-map').length && $('.mapCanvas').find('div').length == 0) {
                $.fn.initEventSingleMap();
            }
            if ($('form#vehicle-search').length > 0 || ($('section.main .inner-form, section.main .form-context').length > 0)) {
                $.fn.initVehicleSearch();
            }
            if ($('body.pwa.page-circuit-list.single').length) {
                window.initProgram();
            }
        }
    }
}

function rebindEventsOnResultLine()
{
    $('div.minus, div.plus').mouseenter(function () {
        $(this).attr('style', 'opacity: 0.9;');
    });

    $('div.minus, div.plus').mouseleave(function () {
        $(this).attr('style', 'opacity: 0.6;');
    });
}

function filterConvert(str)
{
    if (str === undefined) {
        str = '';
    }
    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        .replace(/æ/g, "ae")
        .replace(/Æ/g, "AE")
        .replace(/ð/g, "o")
        .replace(/ø/g, "o")
        .replace(/Ø/g, "O")
        .toLowerCase()
        .replace(/-/g, " ")
        .replace(/'/g, " ")
        .replace(/saint/g, "st")
        ;

    return str;
}

switch ($("#module_name").val()) {
    case 'mon_compte':
        $('#account-menu-trigger').click(function () {
            $('ul.page-tabs-nav').toggleClass('open');
        });
        break;

    case 'faq':
        $('#account-menu-trigger').click(function () {
            $('.top-menu ul.page-tabs-nav').toggleClass('open').toggleClass('hidden-xs').toggleClass('hidden-sm');
        });
        break;
}
